/* Panneau de mariage : le configurateur, sur le patron EXACT de pele-mele.js.
   UNE fonction de dessin sert l'aperçu (canvas dans le cadre) ET le fichier
   d'impression (2200x3178) : ce que la cliente voit est ce qui part en _perso_url.
   product.js cède l'import (#pdp-file) et l'ajout au panier (interception capture),
   et la Finition (Sans perforation / Perforation) n'a plus de ligne d'option : la
   case du bloc upsell est son seul interrupteur (voir product.js, __pdpPanneau). */
(function () {
  "use strict";
  if (!window.__pdpPanneau) return;
  var $ = function (s) { return document.querySelector(s); };
  var T = window.__pdpPanneauT || {};
  var TI = window.MURMURE_I18N || {};
  /* ⛔ LE PANNEAU VOITURE EST LE PREMIER PAYSAGE. Tout le reste du configurateur est ecrit en
     portrait : le cadre, la sonde et la composition d'impression lisaient RATIO en dur. Le
     sens est desormais une propriete du TYPE, et il descend partout par ratioDe(). */
  var RATIOS = { voiture: 50 / 35 };
  /* ⛔ LE PANNEAU EST DECOUPE AUX CENTIMETRES DE LA TAILLE, PAS AU RAPPORT DES AFFICHES.
     0,6923 est la zone imprimee de la famille d'affiches ; une plaque 50 x 70 fait 5/7,
     et le 50 x 35 se vend sur TOUS les types, pas seulement la voiture : choisi, il rend
     le panneau paysage. L'apercu ET le fichier d'impression suivent donc la taille choisie
     (ratioCourant), sinon un plan de table commande en 50 x 35 partait compose en portrait.
     Les vignettes de type, elles, gardent ratioDe : la carte d'un type ne suit pas la
     taille en cours, elle montre la silhouette canonique du type. */
  function ratioDe(type) { return RATIOS[type || etat.type] || 5 / 7; }
  function ratioCourant() {
    var m = String(etat.taille || "").match(/^(\d+)\s*X\s*(\d+)$/i);
    if (m) return Number(m[1]) / Number(m[2]);
    return ratioDe(etat.type);
  }

  var zone = document.getElementById("panneau-zone");
  if (!zone) return;

  /* ---- Etat ---- */
  /* ⛔ UN FOND SUR LEQUEL ON NE LIT PAS N'EST PAS UNE COULEUR, C'EST UN PANNEAU RATE.
     Adrien, 06/08/2026 : « on ne voit pas le texte a cause du manque de contraste ». Mesure
     WCAG des trois fonds colores d'origine, encre claire comprise : sauge 2,54:1, camel
     2,53:1, terracotta 3,70:1. Le seuil de lisibilite est 4,5:1 ; le blanc, seul correct,
     etait a 13,7. Un panneau de mariage se lit a cinq metres dans une salle de reception.
     Les trois teintes sont donc ASSOMBRIES a teinte constante jusqu'a passer le seuil (le nom
     ne change pas : c'est lui qui part en production), et quatre fonds franchement fonces les
     rejoignent, dans les couleurs de mariage du moment. Chacun est annote de son contraste :
     une valeur retouchee a l'oeil se verifie en une seconde. */
  /* Creme et beige ajoutes le 07/08/2026 : les tons chauds clairs sont la moitie du marche du
     mariage, et le nuancier n'offrait qu'un blanc casse d'un cote et sept fonces de l'autre.
     Encre chaude sur fond chaud, contraste mesure comme les autres. */
  var FONDS = {
    blanc: { fond: "#FBFAF7", encre: "#2C2A26", doux: "#8A8175" },          // 13,7:1
    creme: { fond: "#F3EADA", encre: "#3A342A", doux: "#8A7F6C" },          // 10,3:1
    beige: { fond: "#E4D9C8", encre: "#3A342A", doux: "#7E7263" },          //  8,8:1
    sauge: { fond: "#5C6B54", encre: "#F4EFE5", doux: "#D9D2C4" },          //  4,97:1
    terracotta: { fond: "#8A4B37", encre: "#F4EFE5", doux: "#E2CDBD" },     //  5,83:1
    camel: { fond: "#8A6642", encre: "#F4EFE5", doux: "#E6D8C4" },          //  4,51:1
    foret: { fond: "#2E4034", encre: "#F4EFE5", doux: "#D9D2C4" },          //  9,65:1
    nuit: { fond: "#243447", encre: "#F4EFE5", doux: "#D4DAE2" },           // 11,06:1
    bordeaux: { fond: "#5A2A33", encre: "#F4EFE5", doux: "#E4CFD2" },       // 10,10:1
    chocolat: { fond: "#43332A", encre: "#F4EFE5", doux: "#E0D3C6" }        // 10,50:1
  };
  /* ⛔ L'ORDRE, PAS LE MOT. Ces cinq slugs sont ranges comme les valeurs de l'option Type le sont
     cote Shopify. Le libelle affiche est traduit depuis le 07/08/2026 : un Neerlandais recoit
     « Drankenkaart » dans variant.option1, et la comparaison a « Panneau de bar » echouait en
     silence, ce qui ramenait tout le monde au panneau de bienvenue (galerie, H1, prix, dessin).
     Le rang, lui, est identique dans les treize langues. Le francais reste en secours pour le cas
     ou la page n'aurait pas publie ses valeurs. */
  var SLUGS = ["bienvenue", "plan", "photo", "bar", "voiture"];
  var VALEURS = (window.__pdpPanneauValeurs && window.__pdpPanneauValeurs.length === SLUGS.length)
    ? window.__pdpPanneauValeurs
    : ["Panneau de bienvenue", "Plan de table", "Panneau photo", "Panneau de bar", "Panneau voiture"];
  var TYPES = {};
  SLUGS.forEach(function (s, i) { TYPES[VALEURS[i]] = s; });
  /* Les deux finitions, dans l'ordre de l'option : sans perforation, puis avec. */
  var FIN = (window.__pdpPanneauFinitions && window.__pdpPanneauFinitions.length === 2)
    ? window.__pdpPanneauFinitions
    : ["Sans perforation", "Perforation"];
  /* La palette d'encres et la grille de polices de la perso et du pele-mele : les memes. */
  var MATS = {
    blanc: "#FFFFFF", creme: "#F5EFE3", sable: "#E8DFD0", sauge: "#C9D2C0",
    poudre: "#E8D3CE", brume: "#CBD5DC", terracotta: "#C67B5C", ocre: "#C8A96B",
    lilas: "#D8D0E4", foret: "#31473A", marine: "#26334D", noir: "#1A1A1A"
  };
  /* ⛔ PAS D'IMPACT SUR UN PANNEAU DE MARIAGE (Adrien, 06/08/2026 : « police pas adaptee a un
     mariage, remplace par une autre »). Impact est une grotesque de titre de journal : elle
     n'existe dans la grille que parce que la perso la propose pour des affiches de message.
     A sa place, Playfair Display, la didone que la maison imprime deja (runway polices/
     playfair.ttf) : meme registre de force, mais avec le contraste et les empattements fins
     d'un faire-part. L'identifiant change avec elle : `bold` disait la graisse, pas la police,
     et il designe encore Anton a l'impression de la bande perso. */
  var POLICES = {
    classic: "Georgia,'Times New Roman',serif",
    modern: "Arial,Helvetica,sans-serif",
    elegant: "Palatino,'Palatino Linotype',Georgia,serif",
    playfair: "'Playfair Display',Georgia,'Times New Roman',serif",
    script: "'Great Vibes','Apple Chancery',cursive",
    marcellus: "Marcellus,serif",
    garamond: "'Cormorant Garamond',Garamond,serif",
    cinzel: "Cinzel,serif"
  };
  /* ⛔ TROIS ESPERLUETTES AU CHOIX (Adrien, 06/08/2026 : « laisse le choix de 3 types
     d'esperluettes pour ce design »). Trois REGISTRES, pas trois nuances : la plume
     (Great Vibes, pleine de deliés), l'italique de labeur (Cormorant, la panse ouverte), et
     la capitale romaine (Cinzel, geometrique et fine). Le corps differe par police parce que
     leur oeil differe : a corps egal, la Cinzel paraissait deux fois plus petite.
     ⚠️ Les polices sont celles du theme, deja servies : aucun fichier de plus. */
  /* ⚠️ NETTEMENT PLUS PETITES QUE LES PRENOMS (Adrien, 07/08/2026 : « elles font la taille du
     texte »). Un signe de liaison qui pese autant que les noms se lit comme une troisieme
     ligne. Les prenoms sont a 0,107 de la largeur : l'esperluette descend sous 0,09, et la
     Cinzel plus bas encore parce que sa capitale remplit toute sa hauteur. */
  var ESPERLUETTES = {
    calligraphie: { police: "'Great Vibes','Snell Roundhand','Apple Chancery',cursive", trait: "400", corps: 0.088 },
    classique: { police: "'Cormorant Garamond',Garamond,Georgia,serif", trait: "italic 500", corps: 0.088 },
    grave: { police: "Cinzel,'Times New Roman',serif", trait: "400", corps: 0.068 }
  };
  var etat = {
    type: "bienvenue",
    /* ⛔ BORDEAUX A L'OUVERTURE (Adrien, 06/08/2026). Le blanc casse etait le defaut : sur une
       carte blanche, le panneau ne se distinguait pas de la page, et le premier ecran ne
       montrait pas ce que le produit sait faire. Un fond fonce le donne a voir tout de suite,
       texte creme compris. */
    fond: "bordeaux",
    /* L'en-tete du panneau de bienvenue est un TEXTE DE LA CLIENTE depuis le 06/08/2026 :
       « Bienvenue au mariage de » n'est plus qu'un exemple, remplacable par « Welcome »,
       « Il etait une fois », ou la formule qu'elle veut. Vide = l'exemple traduit. */
    entete: "",
    esperluette: "calligraphie",
    prenoms: "", date: "", lieu: "",
    tables: "",
    bar: "",
    voiture: "",
    style: "pleine",      /* pleine | editoriale | centre */
    rendu: "couleur",     /* couleur | nb */
    edTitre: "", edSous: "",
    encres: {},           /* { cle de champ: id MATS } */
    polices: {},          /* { cle de champ: id POLICES } : police propre a ce texte */
    masques: {},          /* { cle de champ: true } : texte cache par l'oeil */
    police: "",           /* id POLICES, vide = la serif du dessin */
    taille: "",           /* pilule Taille cliquee (50X70...), re-pressee au rechargement */
    perfo: false,         /* case perforation : ce qui part dans la variante */
    /* ⛔ LE CHOIX DU CLIENT VIT A PART DE L'ETAT FORCE. Le panneau voiture met `perfo` a
       `true` (ses oeillets sont d'origine) ; sans ce second champ, cette valeur forcee
       devenait le choix du client sur tous les autres types. */
    perfoClient: false,
    photoUrl: "",         /* depot MinIO de la photo (URL stable, comme les ph du pele) */
    photoPreview: ""
  };
  var photo = null;        /* { bmp, w, h } */
  var photoDistante = null;/* depot immediat (apercu Studio), l'impression reste la composition */
  /* ⛔ DEUX DEMOS, UNE PAR RENDU (Adrien, 07/08/2026). Un seul noir et blanc servait les deux
     boutons : en « Couleur », le client voyait une image en noir et blanc et pouvait croire
     que le produit ne sait pas faire autrement. Chaque rendu montre donc la meilleure image
     de son registre, et le bouton dit ce qu'il fait. Les deux sont des seances de couple
     d'avant le jour J, jamais le mariage lui-meme. */
  var demoPhoto = null;       /* le noir et blanc, pour le rendu « nb » */
  var demoPhotoCouleur = null;/* la couleur, pour le rendu « couleur » */
  var occupe = false;

  var CLE_SESSION = "panneau-mariage";
  function persiste() {
    try { sessionStorage.setItem(CLE_SESSION, JSON.stringify(etat)); } catch (e) {}
  }
  (function restaure() {
    try {
      var lu = JSON.parse(sessionStorage.getItem(CLE_SESSION) || "null");
      if (lu && typeof lu === "object") Object.keys(etat).forEach(function (k) {
        if (typeof lu[k] === typeof etat[k]) etat[k] = lu[k];
      });
    } catch (e) {}
  })();

  /* ---- Petites aides de dessin ---- */
  function fitTaille(g, txt, famille, graisse, taille, maxW, ls) {
    /* ⛔ LE PLANCHER NE DOIT JAMAIS DEPASSER LA TAILLE DEMANDEE. Il valait 8 px en dur : sur
       une vignette de type large de 70 px, le corps demande vaut 1,9 px, la boucle ne tournait
       meme pas et la fonction rendait 8, soit QUATRE FOIS plus grand que voulu. Le texte
       d'accueil sortait alors des deux cotes de la vignette (« ENUE AU MARIA »). */
    /* ⛔⛔ ET IL EST RELATIF, PAS EN PIXELS. C'EST UNE DIVERGENCE ECRAN / IMPRESSION.
       Le meme dessin est trace deux fois : sur un canvas d'apercu large de quelques centaines de
       pixels, et sur le fichier de 2200. Un plancher de 8 px vaut 1,1 % de la largeur a l'apercu
       et 0,36 % dans le fichier : sur un texte long, la reduction s'arretait donc PLUS TOT a
       l'ecran que dans le fichier, et le client voyait deborder ce qui rentrait a l'impression,
       ou l'inverse. Meme raison pour le pas, qui etait borne a 1 px : a petite echelle il
       dominait, a grande echelle non, et les deux traces ne s'arretaient pas au meme cran.
       Tout ce qui decide d'une TAILLE doit etre exprime en fraction de la taille demandee, qui
       est elle-meme une fraction de la largeur. Sinon les deux rendus divergent en silence.
       ⚠️ Le plancher reste sous la taille demandee, ce que le cas de la vignette de 70 px
       exigeait deja : 28 % d'un corps de 1,9 px vaut 0,53 px, la boucle tourne, et la fonction
       ne rend jamais plus grand que ce qu'on lui a demande. */
    var plancher = taille * 0.28;
    for (var t = taille; t > plancher; t -= taille * 0.04) {
      g.font = graisse + " " + Math.max(1, Math.round(t)) + "px " + famille;
      var w = g.measureText(txt).width + ls * Math.max(0, txt.length - 1);
      if (w <= maxW) return t;
    }
    return plancher;
  }
  /* Interlettrage a la main : canvas letterSpacing n'existe pas partout (pele-mele). */
  function texteEspace(g, txt, cx, y, ls) {
    var total = g.measureText(txt).width + ls * Math.max(0, txt.length - 1);
    var x = cx - total / 2;
    for (var i = 0; i < txt.length; i++) {
      var c = txt.charAt(i);
      g.fillText(c, x, y);
      x += g.measureText(c).width + ls;
    }
  }
  /* ⛔ « AVEC TEXTE » EST UNE FAMILLE, PAS UN STYLE. Le fichier testait `etat.style ===
     "editoriale"` a quatre endroits ; en ajouter un second style aurait laisse trois de ces
     tests silencieusement faux, et le canvas n'en dit jamais rien. Un seul juge, appele
     partout. */
  function avecTexte() { return etat.style === "editoriale" || etat.style === "centre"; }
  function serif() { return POLICES[etat.police] || "Georgia,'Times New Roman',serif"; }
  /* ⛔ UNE POLICE PAR TEXTE, SANS RENIER CELLE DU PANNEAU (Adrien, 20/08/2026 : « il manque
     l'icone entre oeil et pastille de couleur pour changer la police de chaque texte »). Meme
     cascade que l'encre : la valeur du champ si elle existe, sinon celle du panneau, sinon la
     serif du dessin. Un champ sans choix suit donc le selecteur global, et le client qui ne
     touche a rien ne voit aucune difference. */
  function serifDe(cle) { return POLICES[etat.polices[cle]] || serif(); }
  /* ⛔ L'ESPERLUETTE A SA PROPRE POLICE (Adrien, 06/08/2026 : « utilise une esperluette plus
     stylisee sur le placeholder, c'est un mariage, fais quelque chose d'elegant »). L'italique
     de la serif courante rendait le « & » d'un traitement de texte. Le signe des faire-part est
     calligraphie : c'est le seul endroit du panneau ou la main se voit, et il tient quelle que
     soit la police des prenoms, qui sont en capitales. */
  function calligraphie() { return (ESPERLUETTES[etat.esperluette] || ESPERLUETTES.calligraphie); }
  /* ⛔ UNE SCRIPT NE SE MET NI EN CAPITALES NI EN LETTRES ESPACEES (Adrien, 06/08/2026 :
     « cette police est completement illisible »). Le panneau passe tous ses textes en
     capitales et les ecarte de 1,6 % de la largeur : ce reglage est fait pour des capitales
     romaines. Applique a une anglaise, il coupe les liaisons qui font la lettre et empile des
     boucles isolees, illisibles. La table d'impression le savait deja (`casse: 'aucune'`,
     `interlettre: 0,01` pour Great Vibes dans perso-tirage.js) : l'ecran ne le savait pas. */
  function estScript() { return etat.police === "script"; }
  /* ⛔ UNE ANGLAISE NE SE MET JAMAIS EN CAPITALES, MEME SI LE CLIENT EN TAPE. Great Vibes est
     une ecriture liee : ses capitales sont des lettrines a longues boucles, faites pour ouvrir
     un mot, pas pour s'enchainer. « SACHA & LUCAS » y devient un noeud illisible, et c'est
     exactement le reproche d'Adrien, deux fois : le 06/08/2026 (« cette police est completement
     illisible ») puis le 07/08. On laissait passer sa saisie telle quelle, donc ses capitales
     avec ; on la ramene desormais en capitale d'attaque, ce pour quoi cette police est dessinee.
     Le trait d'union et l'apostrophe ouvrent un mot au meme titre qu'une espace : « Jean-Paul »
     et « L'Isle » gardent leurs deux capitales. */
  function capitaleDAttaque(t) {
    var s = String(t);
    /* ⚠️ ON NE TOUCHE QU'AUX TEXTES ENTIEREMENT EN CAPITALES. Ce sont eux, et eux seuls, que
       l'anglaise ne sait pas rendre. Tout remettre en capitale d'attaque abimait ce que le
       client avait bien ecrit : « 7 juin 2026 » ressortait « 7 Juin 2026 », alors qu'un mois
       ne prend pas de capitale en francais. Un texte deja en bas de casse est laisse tel quel. */
    if (/[a-zà-ÿ]/.test(s) || (s.match(/[A-ZÀ-Þ]/g) || []).length < 2) return s;
    return s.toLocaleLowerCase("fr").replace(
      /(^|[\s'’\-–(])([a-zà-ÿ])/g,
      function (_, avant, lettre) { return avant + lettre.toLocaleUpperCase("fr"); });
  }
  function casse(t) { return estScript() ? capitaleDAttaque(t) : String(t).toUpperCase(); }
  function ecart(v) { return estScript() ? v * 0.12 : v; }
  /* L'encre d'un champ : la teinte choisie, sinon l'encre par defaut passee. */
  /* ⛔ LE DEFAUT D'ENCRE A UN SEUL ENDROIT, ET LE PANNEAU PHOTO N'A PAS DE FOND. `majPastilles`
     prenait `FONDS[etat.fond].encre`, soit le presque-noir du fond blanc, alors que le panneau
     photo dessine son texte en bleu nuit ecrit en dur : la pastille annoncait une couleur que le
     panneau n'utilisait pas (Adrien, 20/08/2026 : « les pastilles de couleur a droite du texte ne
     correspondent pas a la couleur visible »). C'est le MEME defaut qui avait deja ete corrige le
     06/08 pour les fonds fonces ; il est revenu par la porte du type photo, qui n'a pas de fond
     du tout. Un seul juge, cette fois. */
  var ENCRE_PHOTO = "#233047";
  function encreDefaut() {
    if (etat.type === "photo") return ENCRE_PHOTO;
    return (FONDS[etat.fond] || FONDS.blanc).encre;
  }
  function encreDe(cle, defaut) { return MATS[etat.encres[cle]] || defaut; }
  /* ⛔ L'OEIL MASQUE, IL N'EFFACE PAS (meme regle que le pele-mele) : la valeur reste dans le
     champ, seul le dessin la saute. Le client retrouve son texte en reaffichant. */
  function masque(cle) { return !!etat.masques[cle]; }
  /* ⛔ `document.fonts.ready` NE SUFFIT PAS, ET C'EST UN PIEGE SILENCIEUX. Il n'attend que les
     polices DEJA demandees, or une @font-face n'est demandee que si du texte du DOM l'emploie :
     un canvas, lui, ne declenche aucun telechargement. Great Vibes, Marcellus, Cinzel et
     Cormorant sont declarees dans base.css et servies depuis le theme, mais tant que personne
     ne les a reclamees le canvas dessine avec le repli systeme, sans rien signaler, a l'ecran
     COMME DANS LE FICHIER D'IMPRESSION (le panneau est compose dans le navigateur). On les
     reclame donc explicitement, comme le fait deja le pele-mele. */
  function chargePolices() {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    /* Les trois esperluettes sont proposees en vignettes : leurs polices doivent etre la
       AVANT le premier trace, pas seulement celle qui est choisie. */
    var lots = [
      document.fonts.load('400 24px "Great Vibes"'),
      document.fonts.load('italic 500 24px "Cormorant Garamond"'),
      document.fonts.load("400 24px Cinzel")
    ];
    /* ⛔ TOUTES LES POLICES EMPLOYEES, PAS SEULEMENT CELLE DU PANNEAU. Depuis qu'un texte peut
       avoir SA police, `etat.police` ne dit plus ce qui sera dessine : un titre en Marcellus
       avec un panneau en Georgia ne chargeait rien, et le canvas le dessinait avec le repli, a
       l'ecran COMME DANS LE FICHIER. La divergence que ce meme fichier decrit dix lignes plus
       haut, reintroduite par la porte de la police par champ le 20/08/2026. */
    var voulues = {};
    if (etat.police) voulues[etat.police] = true;
    Object.keys(etat.polices || {}).forEach(function (k) { if (etat.polices[k]) voulues[etat.polices[k]] = true; });
    Object.keys(voulues).forEach(function (id) {
      var fam = POLICES[id];
      if (!fam) return;
      ["400", "500", "700"].forEach(function (gr) {
        try { lots.push(document.fonts.load(gr + " 24px " + fam)); } catch (e) {}
      });
    });
    return Promise.all(lots).catch(function () {});
  }

  function coupePrenoms(brut) {
    var t = String(brut || "").trim();
    if (!t) return null;
    var m = t.match(/^(.{2,})\s+(?:et|&|and|und|en|y|e|i|och|és)\s+(.{2,})$/i);
    if (m) return { un: m[1], et: true, deux: m[2] };
    return { un: t, et: false, deux: "" };
  }

  /* ---- Bienvenue : le layout du visuel de reference (1400x2000) ---- */
  function dessineBienvenue(g, W, H, apercu) {
    var f = FONDS[etat.fond] || FONDS.blanc;
    g.fillStyle = f.fond; g.fillRect(0, 0, W, H);
    /* ⛔ PLUS AUCUN FILTRE D'OPACITE SUR LES APERCUS (Adrien, 06/08/2026 : « vire le filtre
       d'opacite sur tous les placeholders de ce produit »). L'apercu etait pose a 50 % tant
       que rien n'etait saisi, pour dire « ceci est un exemple ». Le prix a payer etait trop
       lourd : un blanc pur ressortait en beige a moitie transparent, un fond fonce paraissait
       delave, et le client jugeait le produit sur une image que nous affaiblissions nous-memes.
       Un exemple doit montrer ce qu'on sait faire, a pleine force. Le texte de demonstration
       dit deja qu'il est un exemple : ce sont des prenoms qui ne sont pas les siens. */
    g.fillStyle = f.encre;
    g.globalAlpha = 1;
    g.textBaseline = "alphabetic";

    g.fillStyle = encreDe("entete", f.encre);
    var enTete = (etat.entete || T.entete || "Bienvenue au Mariage de");
    var teTaille = fitTaille(g, enTete, serifDe("entete"), "500", W * 0.027, W * 0.84, W * 0.005);
    g.font = "500 " + Math.round(teTaille) + "px " + serifDe("entete");
    texteEspace(g, enTete, W / 2, H * 0.278, W * 0.005);

    g.fillStyle = encreDe("prenoms", f.encre);
    var pren = coupePrenoms(etat.prenoms) || coupePrenoms(T.prenoms_ph || "Johanna et Corentin");
    var nomTaille = W * 0.107;
    if (pren.et) {
      var n1 = casse(pren.un), n2 = casse(pren.deux);
      var lsNom = ecart(W * 0.016);
      var t1 = fitTaille(g, n1, serifDe("prenoms"), "400", nomTaille, W * 0.86, lsNom);
      var t2 = fitTaille(g, n2, serifDe("prenoms"), "400", nomTaille, W * 0.86, lsNom);
      var t = Math.min(t1, t2);
      g.font = "400 " + Math.round(t) + "px " + serifDe("prenoms");
      texteEspace(g, n1, W / 2, H * 0.395, lsNom);
      texteEspace(g, n2, W / 2, H * 0.565, lsNom);
      /* ⛔ UNE ESPERLUETTE, PAS « et » SUIVI D'UN TRAIT (Adrien, 06/08/2026). Les deux
         signes disaient la meme chose deux fois : le mot, puis un trait courbe cense
         l'orner. L'esperluette dit la liaison a elle seule, et c'est le signe des faire-part.
         ⚠️ ELLE EST CENTREE, la ou « et » etait decale de 6 % vers la gauche pour laisser la
         place au trait. Sans ce trait, le decalage n'a plus de raison d'etre et se verrait. */
      /* ⚠️ Une lettre calligraphiee ne se place pas comme une lettre de labeur : son encre
         deborde de sa chasse (le delie part a gauche du point d'origine) et elle descend sous
         la ligne de base. On la centre donc sur sa BOITE D'ENCRE, et verticalement au milieu du
         blanc reel entre les deux prenoms : le pied du prenom du dessus et le sommet des
         capitales de celui du dessous. Une ordonnee fixe la faisait plonger vers le second nom
         des que les prenoms changeaient de longueur, donc de corps. */
      var eSigne = "&";
      var esp = calligraphie();
      var eTaille = Math.round(W * esp.corps);
      g.font = esp.trait + " " + eTaille + "px " + esp.police;
      var me = g.measureText(eSigne);
      var eHaut = me.actualBoundingBoxAscent || eTaille * 0.62;
      var eBas = me.actualBoundingBoxDescent || eTaille * 0.22;
      var hautCaps = Math.round(t) * 0.7;
      var base = (H * 0.395 + (H * 0.565 - hautCaps)) / 2 + (eHaut - eBas) / 2;
      var eG = me.actualBoundingBoxLeft, eD = me.actualBoundingBoxRight;
      var xE = (eG != null && eD != null && eG + eD > 0)
        ? W / 2 - (eD - eG) / 2
        : W / 2 - me.width / 2;
      g.fillText(eSigne, xE, base);
    } else {
      var seul = casse(pren.un);
      var lsSeul = ecart(W * 0.016);
      var ts = fitTaille(g, seul, serifDe("prenoms"), "400", nomTaille, W * 0.86, lsSeul);
      g.font = "400 " + Math.round(ts) + "px " + serifDe("prenoms");
      texteEspace(g, seul, W / 2, H * 0.48, lsSeul);
    }

    g.fillStyle = encreDe("date", f.encre);
    var date = casse(etat.date || T.date_ph || "26 octobre 2026");
    g.font = "500 " + Math.round(W * 0.0285) + "px " + serifDe("date");
    texteEspace(g, date, W / 2, H * 0.758, ecart(W * 0.008));
    if (etat.lieu) {
      g.fillStyle = encreDe("lieu", f.encre);
      g.font = "400 " + Math.round(W * 0.021) + "px " + serifDe("lieu");
      texteEspace(g, etat.lieu, W / 2, H * 0.80, ecart(W * 0.004));
    }
    g.globalAlpha = 1;
  }

  /* ---- Plan de table : LE PLAN de TABLE + colonnes ---- */
  /* ⛔ PLUS DE COUPE SILENCIEUSE. `slice(0, 12)` et `slice(0, 10)` jetaient sans rien dire tout
     ce qui depassait : une mariee qui saisissait ses 14 tables en voyait 12, et rien ne le lui
     disait. On rend TOUT ce qui est saisi ; c'est le dessin qui decide de ce qui tient, et
     `planTropCharge()` qui refuse l'ajout au panier en le disant. Le champ garde son
     maxlength de 4 000 signes, qui est la vraie borne du navigateur. */
  function lignesTables() {
    var brut = String(etat.tables || "").split(/\n+/).map(function (l) { return l.trim(); }).filter(Boolean);
    return brut.map(function (l) {
      var i = l.indexOf(":");
      if (i < 0) return { titre: l, invites: [] };
      return {
        titre: l.slice(0, i).trim(),
        invites: l.slice(i + 1).split(",").map(function (x) { return x.trim(); }).filter(Boolean)
      };
    });
  }

  /* ---- Ce qui tient sur un plan de table, et a quelle taille de lettre ----------------------
     ⛔ L'AVANCE DE RANGEE ETAIT UNE CONSTANTE, ET C'EST TOUT LE DEFAUT. Elle valait
     `1,35 pas + 6,4 pas + 0,028 H`, quel que soit le contenu : une rangee de tables de 8 noms
     debordait donc de deux lignes sur le titre de la rangee suivante, et une quatrieme rangee
     demarrait sous le pied du panneau. Mesure du 17/08/2026, cinq rendus du vrai configurateur
     relus a l'oeil (Downloads/_serie403) : 9 tables de 7 noms tenaient, 9 de 8 se chevauchaient,
     6 de 9 se chevauchaient AUSSI en laissant le tiers bas vide, 12 de 6 tombaient hors cadre,
     et au-dela de 12 les tables suivantes disparaissaient. Or la table ronde de 8 et celle de 10
     sont la norme dans les salles francaises : le produit cassait sur le cas le PLUS courant.

     ⛔ LE DESSIN SE PLIE AU CONTENU. Chaque rangee avance de SON bloc le plus haut, et si
     l'ensemble depasse la zone utile, tout se resserre d'un facteur unique. Un facteur unique et
     non par rangee : deux rangees a deux corps differents se liraient comme deux affiches.

     ⛔ LE PLANCHER EST EN MILLIMETRES REELS, PAS EN PIXELS. Un plan de table se lit a bout de
     bras, dans une file. La capitale d'un prenom mesure 0,0132 de la largeur du panneau (releve
     au pixel sur le rendu du 17/08), soit 6,6 mm en 50x70 et 13,2 mm en 100x140 : le meme
     facteur de reduction ne coute donc pas la meme chose selon la cote. On borne la capitale a
     5,5 mm, lisible a environ 80 cm, et c'est CA qui fait qu'une plus grande cote accueille plus
     d'invites. Jusqu'ici la grille etant en pure proportion, un 100x140 ne tenait pas une table
     de plus qu'un 50x70 : il se lisait seulement de plus loin, ce que la FAQ laissait deja
     croire l'inverse. */
  var PLAN_HAUT = 0.32, PLAN_BAS = 0.955;   /* zone utile, en part de la hauteur */
  var PLAN_PAS = 0.0245;                    /* interligne des invites, idem */
  var PLAN_ECART = 0.028;                   /* respiration entre deux rangees */
  var PLAN_TITRE = 1.35;                    /* le titre de table pese 1,35 interligne */
  var PLAN_CAP_PART = 0.0132;               /* capitale d'un prenom, en part de la LARGEUR */
  var PLAN_CAP_MIN_MM = 5.5;                /* sous quoi un prenom ne se lit plus a bout de bras */

  /* La largeur du panneau en millimetres, depuis la cote choisie (« 70X100 » -> 700). */
  function largeurMm(taille) {
    var m = String(taille || "").match(/^(\d+)\s*[Xx]\s*(\d+)$/);
    return m ? Number(m[1]) * 10 : 500;
  }

  /* Les rangees de trois, avec le nombre d'invites du bloc le plus haut de chacune. */
  function rangeesDe(tabs) {
    var r = [];
    for (var i = 0; i < tabs.length; i += 3) {
      var haut = 0;
      for (var j = i; j < Math.min(i + 3, tabs.length); j++) haut = Math.max(haut, tabs[j].invites.length);
      r.push(haut);
    }
    return r;
  }

  /* Ce que le panneau peut porter : le facteur de reduction, et ce qui deborde malgre lui. */
  function planMetrique(tabs, taille) {
    var rangees = rangeesDe(tabs);
    var naturelle = 0;
    for (var i = 0; i < rangees.length; i++) {
      naturelle += (PLAN_TITRE + rangees[i]) * PLAN_PAS;
      if (i < rangees.length - 1) naturelle += PLAN_ECART;
    }
    var dispo = PLAN_BAS - PLAN_HAUT;
    var k = naturelle > dispo ? dispo / naturelle : 1;
    /* Le plancher, exprime dans la cote reelle : k ne descend pas sous lui. */
    var kPlancher = PLAN_CAP_MIN_MM / (PLAN_CAP_PART * largeurMm(taille));
    var kRetenu = Math.max(k, Math.min(1, kPlancher));
    /* Combien de rangees entrent VRAIMENT a ce facteur : au plancher, les dernieres sautent. */
    var reste = dispo, posees = 0;
    for (var r = 0; r < rangees.length; r++) {
      var h = (PLAN_TITRE + rangees[r]) * PLAN_PAS * kRetenu + (r ? PLAN_ECART * kRetenu : 0);
      if (h > reste + 1e-9) break;
      reste -= h; posees++;
    }
    return {
      k: kRetenu,
      rangees: rangees.length,
      rangeesPosees: posees,
      tablesPosees: Math.min(tabs.length, posees * 3),
      deborde: posees < rangees.length
    };
  }

  /* Le refus, lu par `requisManquant()` : un plan qu'on ne saurait pas imprimer entier ne part
     pas au panier en silence. */
  function planTropCharge() {
    if (etat.type !== "plan") return null;
    var tabs = lignesTables();
    if (!tabs.length) return null;
    return planMetrique(tabs, etat.taille || "50X70").deborde ? tabs : null;
  }
  /* ---- Le titre a trois lignes, partage par le plan de table et la carte du bar ----
     ⛔ UNE LIGNE VIDE EST UN CHOIX, PAS UN OUBLI. Le repli `T.plan_l1 || "LE PLAN"` retombait
     sur le FRANCAIS des qu'une langue laissait la ligne vide : c'est ce qui bloquait le
     retrait de l'article allemand (« DER TISCHPLAN » ne peut pas perdre son article sans
     laisser `plan_l1` vide). On distingue donc « absent » de « vide » avec `!= null`, et une
     ligne vide ne se dessine pas : le titre remonte alors sur deux lignes au lieu de trois.
     ⚠️ Ecrit UNE fois pour les deux panneaux : la carte du bar reprend exactement la meme
     tete, traits compris. Deux copies auraient diverge des la premiere retouche. */
  function titreTroisLignes(g, W, H, f, l1, l2, l3) {
    if (!l1) { l1 = l3; l3 = ""; }
    g.font = "500 " + Math.round(W * 0.082) + "px " + serifDe("titre");
    if (l1) texteEspace(g, casse(l1), W / 2, H * (l2 ? 0.125 : 0.14), ecart(W * 0.018));
    if (l2) {
      /* La petite ligne du milieu, encadree de deux traits ; certaines langues n'en ont pas. */
      g.font = "italic 400 " + Math.round(W * 0.042) + "px " + serifDe("titre");
      var wDe = g.measureText(l2).width;
      g.fillText(l2, W / 2 - wDe / 2, H * 0.172);
      g.save();
      g.strokeStyle = f.encre; g.lineWidth = Math.max(1, W * 0.0012);
      g.beginPath();
      g.moveTo(W * 0.40, H * 0.163); g.lineTo(W / 2 - wDe / 2 - W * 0.02, H * 0.163);
      g.moveTo(W / 2 + wDe / 2 + W * 0.02, H * 0.163); g.lineTo(W * 0.60, H * 0.163);
      g.stroke();
      g.restore();
    }
    g.font = "500 " + Math.round(W * 0.082) + "px " + serifDe("titre");
    if (l3) texteEspace(g, casse(l3), W / 2, H * (l2 ? 0.235 : 0.215), ecart(W * 0.018));
  }

  function dessinePlan(g, W, H, apercu) {
    var f = FONDS[etat.fond] || FONDS.blanc;
    g.fillStyle = f.fond; g.fillRect(0, 0, W, H);
    var saisies = lignesTables();

    var tables = saisies.length ? saisies : (function () {
      var d = [];
      for (var i = 1; i <= 9; i++) d.push({
        titre: (T.table || "Table") + " " + i,
        invites: [1, 2, 3, 4, 5, 6].map(function (n) { return (T.invite || "Invité") + " " + n; })
      });
      return d;
    })();
    g.fillStyle = f.encre;
    g.globalAlpha = 1;
    g.textBaseline = "alphabetic";

    titreTroisLignes(g, W, H, f,
      (T.plan_l1 != null ? T.plan_l1 : "LE PLAN"),
      (T.plan_l2 != null ? T.plan_l2 : "de"),
      (T.plan_l3 != null ? T.plan_l3 : "TABLE"));

    g.fillStyle = encreDe("tables", f.encre);
    var cols = [W * 0.168, W * 0.5, W * 0.832];
    var mes = planMetrique(tables, etat.taille || "50X70");
    var k = mes.k;
    var rangY = H * PLAN_HAUT;
    var pasLigne = H * PLAN_PAS * k;
    var rangees = rangeesDe(tables);
    /* ⛔ ON NE DESSINE QUE LES RANGEES QUI TIENNENT. Une rangee a moitie hors du panneau est
       pire qu'une rangee absente : elle a l'air imprimable a l'ecran. `planTropCharge()`
       refuse alors l'ajout au panier, et la cliente sait quoi faire. */
    var vues = Math.min(tables.length, mes.rangeesPosees * 3);
    for (var i = 0; i < vues; i++) {
      var cx = cols[i % 3];
      var y = rangY;
      g.font = "600 " + Math.round(W * 0.023 * k) + "px " + serifDe("tables");
      texteEspace(g, casse(tables[i].titre), cx, y, ecart(W * 0.006 * k));
      y += pasLigne * PLAN_TITRE;
      g.font = "400 " + Math.round(W * 0.0185 * k) + "px " + serifDe("tables");
      g.save();
      /* Les 0,72 restent : ce sont les noms d'invites, volontairement plus legers que les
         titres de table. C'est une hierarchie de lecture, pas un filigrane. */
      g.globalAlpha = 0.72;
      for (var j = 0; j < tables[i].invites.length; j++) {
        var inv = tables[i].invites[j];
        g.fillText(inv, cx - g.measureText(inv).width / 2, y);
        y += pasLigne;
      }
      g.restore();
      /* ⛔ L'AVANCE SUIT LE BLOC LE PLUS HAUT DE LA RANGEE, jamais une constante. */
      if (i % 3 === 2) rangY += (PLAN_TITRE + rangees[(i - 2) / 3]) * pasLigne + H * PLAN_ECART * k;
    }
    g.globalAlpha = 1;
  }

  /* ---- Carte du bar : CARTE du BAR + les boissons, une par ligne ----
     Meme grammaire de saisie que le plan de table, « nom : ingredients », parce que la
     cliente vient de l'apprendre a l'ecran d'avant (Adrien, 07/08/2026). Une seule colonne :
     un cocktail se lit en entier, il ne se cherche pas comme un nom dans une liste. */
  function lignesBoissons(brut) {
    return String(brut || "").split(/\n+/)
      .map(function (l) { return l.trim(); })
      .filter(Boolean)
      .slice(0, 10)
      .map(function (l) {
        var i = l.indexOf(":");
        if (i < 0) return { nom: l, detail: "" };
        return { nom: l.slice(0, i).trim(), detail: l.slice(i + 1).trim() };
      });
  }
  function dessineBar(g, W, H, apercu) {
    var f = FONDS[etat.fond] || FONDS.blanc;
    g.fillStyle = f.fond; g.fillRect(0, 0, W, H);
    var saisies = lignesBoissons(etat.bar);
    var liste = saisies.length ? saisies : lignesBoissons(T.bar_ph || "");
    g.fillStyle = f.encre;
    g.globalAlpha = 1;
    g.textBaseline = "alphabetic";

    titreTroisLignes(g, W, H, f,
      (T.bar_l1 != null ? T.bar_l1 : "CARTE"),
      (T.bar_l2 != null ? T.bar_l2 : "du"),
      (T.bar_l3 != null ? T.bar_l3 : "BAR"));

    g.fillStyle = encreDe("bar", f.encre);
    /* Le pas s'adapte au nombre de boissons : deux cocktails ne doivent pas laisser les deux
       tiers du panneau vides, dix ne doivent pas deborder. La plage utile va de 0,32 a 0,90
       de la hauteur, et le corps du texte suit le pas. */
    var haut = H * 0.33, bas = H * 0.90;
    var pas = (bas - haut) / Math.max(4, liste.length);
    var corpsNom = Math.min(W * 0.030, pas * 0.42);
    var corpsDetail = corpsNom * 0.68;
    var y = haut + pas * 0.5;
    for (var i = 0; i < liste.length; i++) {
      g.font = "600 " + Math.round(corpsNom) + "px " + serifDe("bar");
      texteEspace(g, casse(liste[i].nom), W / 2, y, ecart(W * 0.007));
      if (liste[i].detail) {
        g.save();
        /* Les ingredients sont volontairement plus legers que le nom : une hierarchie de
           lecture, la meme que les invites sous un numero de table. */
        g.globalAlpha = 0.72;
        g.font = "italic 400 " + Math.round(corpsDetail) + "px " + serifDe("bar");
        var d = liste[i].detail;
        g.fillText(d, W / 2 - g.measureText(d).width / 2, y + corpsNom * 1.15);
        g.restore();
      }
      y += pas;
    }
    g.globalAlpha = 1;
  }

  /* ---- Panneau voiture : la plaque a accrocher a l'arriere de la voiture des maries ----
     ⚠️ LE SEUL PAYSAGE, et c'est la contrainte qui commande le dessin. Sur 50 x 35 cm lus a
     dix metres, en mouvement, il n'y a de la place que pour UNE phrase et les prenoms. Les
     corps se calculent donc sur la HAUTEUR, pas sur la largeur : en paysage, un corps en
     fraction de largeur donne des lettres deux fois trop petites. */
  function dessineVoiture(g, W, H, apercu) {
    var f = FONDS[etat.fond] || FONDS.blanc;
    g.fillStyle = f.fond; g.fillRect(0, 0, W, H);
    g.globalAlpha = 1;
    g.textBaseline = "alphabetic";

    var phrase = casse(etat.voiture || T.voiture_ph || "Just Married");
    g.fillStyle = encreDe("voiture", f.encre);
    /* L'interlettrage reste MODESTE ici : sur une plaque, chaque point d'ecart mange de la
       taille de lettre, et c'est la taille qui se lit a dix metres, pas l'espacement. */
    var lsPhrase = ecart(H * 0.022);
    var tPhrase = fitTaille(g, phrase, serifDe("voiture"), "500", H * 0.30, W * 0.88, lsPhrase);
    g.font = "500 " + Math.round(tPhrase) + "px " + serifDe("voiture");
    texteEspace(g, phrase, W / 2, H * 0.47, lsPhrase);

    /* Les prenoms sous la phrase, relies par l'esperluette choisie : la meme que le panneau
       de bienvenue, pour que les deux pieces du meme mariage se ressemblent. */
    var pren = coupePrenoms(etat.prenoms) || coupePrenoms(T.prenoms_ph || "Estelle et Hugo");
    var ligne = pren.et ? [casse(pren.un), casse(pren.deux)] : [casse(pren.un)];
    g.fillStyle = encreDe("prenoms", f.encre);
    /* Les prenoms restent SOUS la phrase dans la hierarchie : deux tiers de son corps. A
       taille egale, la plaque presentait deux titres et n'en imposait aucun. */
    var lsNom = ecart(H * 0.014);
    var tNom = Math.round(Math.min(H * 0.075, tPhrase * 0.66));
    g.font = "400 " + tNom + "px " + serifDe("prenoms");
    if (pren.et) {
      var esp = calligraphie();
      var eT = Math.round(tNom * 0.95);
      /* Les trois morceaux sont mesures ensemble puis poses d'un bloc : centrer chacun
         separement ferait danser l'esperluette selon la longueur des prenoms. */
      var wA = g.measureText(ligne[0]).width + lsNom * Math.max(0, ligne[0].length - 1);
      var wC = g.measureText(ligne[1]).width + lsNom * Math.max(0, ligne[1].length - 1);
      g.font = esp.trait + " " + eT + "px " + esp.police;
      var mE = g.measureText("&");
      var wB = mE.width;
      var creux = H * 0.05;
      var total = wA + creux + wB + creux + wC;
      var x = W / 2 - total / 2;
      g.font = "400 " + tNom + "px " + serifDe("prenoms");
      texteEspace(g, ligne[0], x + wA / 2, H * 0.72, lsNom);
      g.font = esp.trait + " " + eT + "px " + esp.police;
      g.fillText("&", x + wA + creux, H * 0.72);
      g.font = "400 " + tNom + "px " + serifDe("prenoms");
      texteEspace(g, ligne[1], x + wA + creux + wB + creux + wC / 2, H * 0.72, lsNom);
    } else {
      texteEspace(g, ligne[0], W / 2, H * 0.72, lsNom);
    }

    if (etat.date) {
      g.fillStyle = encreDe("date", f.encre);
      g.font = "500 " + Math.round(H * 0.052) + "px " + serifDe("date");
      texteEspace(g, casse(etat.date), W / 2, H * 0.86, ecart(H * 0.014));
    }
  }

  /* ---- Panneau photo : pleine ou editoriale ---- */
  function poseCover(g, img, iw, ih, x, y, w, h, nb) {
    var r = iw / ih, rc = w / h;
    var sw = r > rc ? ih * rc : iw;
    var sh = r > rc ? ih : iw / rc;
    var sx = (iw - sw) / 2, sy = (ih - sh) / 2;
    g.save();
    if (nb && "filter" in g) g.filter = "grayscale(1)";
    g.drawImage(img, sx, sy, sw, sh, x, y, w, h);
    g.restore();
    if (nb && !("filter" in g)) {
      /* Repli sans ctx.filter : desaturation par recouvrement. */
      g.save();
      g.globalCompositeOperation = "saturation";
      g.fillStyle = "#808080";
      g.fillRect(x, y, w, h);
      g.restore();
    }
  }
  function dessinePhoto(g, W, H, apercu) {
    g.fillStyle = "#FFFFFF"; g.fillRect(0, 0, W, H);
    var nb = etat.rendu === "nb";
    /* La photo de la cliente passe toujours en premier. A defaut, la demo du rendu choisi :
       le noir et blanc n'a pas de version couleur, et l'inverse non plus. */
    var demo = nb ? (demoPhoto || demoPhotoCouleur) : (demoPhotoCouleur || demoPhoto);
    var src = photo || demo;
    if (etat.style === "centre") {
      /* ⛔ TROIS LIGNES, LA DEUXIEME EN GRAND : c'est la composition du panneau de bienvenue
         (« Nous nous marions » / ESTELLE & HUGO / « 7 juin 2026 »), demandee telle quelle par
         Adrien le 20/08/2026. Le rapport des corps EST le style : trois lignes du meme corps
         ne diraient plus laquelle est le sujet.
         ⚠️ LES TROIS PASSENT PAR `fitTaille`. Le style editorial s'en passait et le texte
         sortait du panneau ; ici les lignes sont pleine largeur, donc le risque est le meme. */
      var mC = W * 0.066;
      /* ⚠️ LE BLOC DE TEXTE EST UN GROUPE, PAS TROIS LIGNES POSEES CHACUNE SUR SON TIERS
         (Adrien, 20/08/2026 : « trop d'espace entre les textes »). Les trois lignes se serrent
         autour de celle du milieu, et c'est la PHOTO qui reprend la place gagnee. */
      var hPhotoC = H * 0.655;
      if (src) poseCover(g, src.bmp, src.w, src.h, mC, mC, W - 2 * mC, hPhotoC, nb);
      else { g.fillStyle = "#F1ECE3"; g.fillRect(mC, mC, W - 2 * mC, hPhotoC); }

      var encreC = encreDefaut();
      var large = W - 2 * mC;
      var hautT = mC + hPhotoC;               /* haut de la zone de texte */
      var basT = H - mC;
      var zone3 = basT - hautT;

      g.save();
      g.textBaseline = "middle";

      /* ⛔ LES LIGNES MASQUEES NE LAISSENT PAS LEUR PLACE VIDE. Les trois ordonnees etaient
         posees en dur : masquer celle du milieu ouvrait un trou entre le titre et la date, et
         masquer les deux petites laissait le grand texte hors du centre. On compose donc la
         liste de ce qui reste, puis on la repartit. Un panneau a deux lignes doit se lire comme
         un panneau dessine pour deux lignes, pas comme un panneau a trou. */
      var lignes = [];
      if (!masque("edTitre")) lignes.push({
        t: casse(etat.edTitre || T.ed_titre_ph || "Notre mariage"),
        cle: "edTitre", corps: W * 0.028, ls: W * 0.005, gr: "500" });
      if (!masque("edSous")) lignes.push({
        t: casse(etat.edSous || T.ed_sous_ph || "Le plus beau des oui"),
        cle: "edSous", corps: W * 0.072, ls: ecart(W * 0.012), gr: "400" });
      if (!masque("edDate")) lignes.push({
        t: casse(etat.date || T.date_ph || "26 octobre 2026"),
        cle: "date", corps: W * 0.022, ls: W * 0.006, gr: "400" });

      /* Les hauteurs de repos, par nombre de lignes restantes. */
      var REPOS = { 1: [0.55], 2: [0.38, 0.68], 3: [0.30, 0.57, 0.81] };
      var repos = REPOS[lignes.length] || [];
      for (var iL = 0; iL < lignes.length; iL++) {
        var L = lignes[iL];
        g.fillStyle = encreDe(L.cle, encreC);
        var cL = fitTaille(g, L.t, serifDe(L.cle), L.gr, L.corps, large, L.ls);
        g.font = L.gr + " " + Math.round(cL) + "px " + serifDe(L.cle);
        texteEspace(g, L.t, W / 2, hautT + zone3 * repos[iL], L.ls);
      }

      g.restore();
    } else if (avecTexte()) {
      var marge = W * 0.066;
      var hPhoto = H * 0.72;
      if (src) {
        poseCover(g, src.bmp, src.w, src.h, marge, marge, W - 2 * marge, hPhoto, nb);
      } else {
        g.fillStyle = "#F1ECE3"; g.fillRect(marge, marge, W - 2 * marge, hPhoto);
      }
      var yBande = marge + hPhoto + (H - marge * 2 - hPhoto) * 0.62;
      var encre = "#233047";
      var xBar = W * 0.52;
      /* ⛔ LE TEXTE SORTAIT DU PANNEAU (Adrien, 20/08/2026, capture : « VELCOME TO THE WEDDING
         OF », le W mange par le bord gauche). Ce style etait le SEUL a poser son corps en dur
         (W * 0.031) sans jamais mesurer : « Notre mariage » tenait, « Welcome to the wedding
         of » debordait de moitie, et rien ne le signalait puisque le canvas ne coupe pas, il
         dessine hors champ. `fitTaille` existe depuis le panneau de bienvenue et fait
         exactement ce travail ; il manquait ici, et seulement ici.
         ⚠️ LES DEUX COLONNES ONT DES LARGEURS DIFFERENTES : le titre va de la marge au filet
         moins une respiration, le sous-titre du filet a la marge opposee. Une seule largeur
         pour les deux ferait deborder l'une ou retrecir l'autre pour rien. */
      var wTitre = xBar - W * 0.03 - marge;
      var wSous = (W - marge) - (xBar + W * 0.035);
      var lsT = W * 0.004;
      g.fillStyle = encreDe("edTitre", encre);
      var tSC = casse(etat.edTitre || T.ed_titre_ph || "Notre mariage");
      var tTaille = fitTaille(g, tSC, serifDe("edTitre"), "500", W * 0.031, wTitre, lsT);
      g.font = "500 " + Math.round(tTaille) + "px " + serifDe("edTitre");
      g.save();
      g.textBaseline = "middle";
      if (!masque("edTitre")) texteEspace(g, tSC, marge + wTitre / 2, yBande, lsT);
      g.strokeStyle = encre; g.lineWidth = Math.max(1, W * 0.0022);
      g.beginPath(); g.moveTo(xBar, yBande - H * 0.028); g.lineTo(xBar, yBande + H * 0.028); g.stroke();
      g.fillStyle = encreDe("edSous", encre);
      var sous = casse(etat.edSous || T.ed_sous_ph || "Le plus beau des oui");
      var mots = sous.split(/\s+/);
      var l1 = mots.slice(0, Math.ceil(mots.length / 2)).join(" ");
      var l2 = mots.slice(Math.ceil(mots.length / 2)).join(" ");
      /* Les deux lignes partagent UN corps : deux corps differents se liraient comme deux
         textes. On prend donc le plus petit des deux qui tiennent. */
      var sTaille = Math.min(fitTaille(g, l1, serifDe("edSous"), "400", W * 0.02, wSous, 0),
                             l2 ? fitTaille(g, l2, serifDe("edSous"), "400", W * 0.02, wSous, 0) : W * 0.02);
      g.font = "400 " + Math.round(sTaille) + "px " + serifDe("edSous");
      var xS = xBar + W * 0.035;
      if (!masque("edSous")) {
        g.fillText(l1, xS, yBande - H * 0.012);
        if (l2) g.fillText(l2, xS, yBande + H * 0.016);
      }
      g.restore();
    } else {
      if (src) {
        poseCover(g, src.bmp, src.w, src.h, 0, 0, W, H, nb);
      } else {
        g.fillStyle = "#F1ECE3"; g.fillRect(0, 0, W, H);
      }
    }
  }

  function dessine(g, W, H, apercu) {
    if (etat.type === "plan") dessinePlan(g, W, H, apercu);
    else if (etat.type === "bar") dessineBar(g, W, H, apercu);
    else if (etat.type === "voiture") dessineVoiture(g, W, H, apercu);
    else if (etat.type === "photo") dessinePhoto(g, W, H, apercu);
    else dessineBienvenue(g, W, H, apercu);
  }

  /* ---- Apercu dans le cadre (patron pele-mele) ---- */
  var interne = document.querySelector(".pdp-frame__inner");
  if (!interne) return;
  var scene = document.createElement("canvas");
  scene.id = "panneau-scene";
  interne.appendChild(scene);
  var ctx = scene.getContext("2d");

  /* ---- Le panneau en situation ---------------------------------------------------------
     ⛔ L'APERCU SE POSE DANS UNE PHOTO, IL NE FLOTTE PLUS SUR DU BLANC (Adrien, 07/08/2026 :
     « il faut mettre le placeholder en situation, sur un panneau, une table, derriere une
     voiture, pour qu'on puisse se projeter »). Trois fonds qu'il a fournis, tous de face, tous
     vides, rien devant : c'est ce qui rend la pose possible sans deviner de perspective.

     ⚠️ CHAQUE FOND EST RECADRE AU RAPPORT DU PRODUIT (0,6923, et 50/35 pour le voiture), le
     panneau centre. Le cadre de la fiche garde donc le rapport qu'il avait, les cotes et la
     maquette ne bougent pas, et le canvas n'a qu'un seul facteur d'echelle a appliquer.

     ⛔ ET LE DESSIN N'EST JAMAIS ETIRE. Le panneau vide de la photo n'a pas le rapport du
     produit : 0,58 sur le chevalet, 2,35 sur la plaque de voiture, contre 0,6923 et 1,4286
     pour de vrai. On y inscrit donc le dessin A SON PROPRE RAPPORT, centre, et on remplit le
     reste du panneau avec sa couleur de fond. Le lettrage du client garde ses proportions,
     exactement celles de l'apercu a plat ; seule la plaque parait plus longue qu'elle n'est.

     ⚠️ RIEN DE TOUT CA NE VA DANS LE FICHIER D'IMPRESSION. La scene est une couche
     d'affichage : `dessine` reste seule a produire le panneau nu, pour les vignettes de type
     comme pour l'impression.
     -------------------------------------------------------------------------------------- */
  var SCENES = {
    bienvenue: "chevalet", photo: "chevalet",
    plan: "table", bar: "table",
    voiture: "voiture"
  };
  var DECORS = {
    /* quad : les quatre coins du panneau vide, dans l'image recadree, releves a la grille
       puis verifies a l'oeil en peignant dedans.
       socle : y ou le support passe devant ; le dessin s'y arrete.
       devant : ce qui doit etre redessine PAR-DESSUS le dessin depuis la photo (le pied noir
       du chevalet et ses deux pinces passent devant la plaque). */
    chevalet: {
      fichier: "panneau-scene-chevalet.jpg", W: 868, H: 1254,
      quad: [[151, 84], [719, 84], [717, 1075], [149, 1075]], socle: 0,
      devant: [[135, 0, 20, 1254], [717, 0, 18, 1254], [136, 412, 38, 24], [697, 412, 38, 25]]
    },
    table: {
      fichier: "panneau-scene-table.jpg", W: 868, H: 1254,
      quad: [[89, 85], [772, 88], [777, 1054], [96, 1051]], socle: 1018, devant: []
    },
    voiture: {
      fichier: "panneau-scene-voiture.jpg", W: 1254, H: 878,
      quad: [[246, 339], [1012, 334], [1009, 659], [252, 665]], socle: 0, devant: []
    }
  };
  var imagesDecor = {};
  /* Faux au chargement : le client arrive sur son panneau, pas sur une piece. */
  var vueScene = false;
  /* Miroir synchrone lu par product.js (sceneAuFormatDeLaPhoto) : en vue panneau, la photo
     de scene ne doit pas imposer son rapport au stage. Pose AVANT tout onload d'image.
     ⛔ ET LE BOUTON SE REACCORDE ICI, PAS CHEZ SES APPELANTS. Un seul des quatre appelants
     rappelait `majBoutonVue` : taper une lettre dans un champ quittait la scene sans rien
     redire au bouton, qui restait sur « Voir mon panneau », presse, alors qu'on regardait
     deja le panneau (Adrien, 08/08/2026). Un etat et son libelle changent ensemble ou pas
     du tout ; l'accord est donc dans le poseur. */
  function poseVueScene(v) {
    vueScene = v; window.__panneauVueScene = v;
    /* ⛔ LA FORME DE LA BOITE CHANGE DANS LA MEME IMAGE QUE LE CLIC. Elle etait posee dans le
       `requestAnimationFrame` de `planifie` : la boite gardait une image entiere le rapport de
       l'etat precedent, et surtout le rapport devenait indissociable du dessin. Un onglet qui
       n'est pas peint ne recoit AUCUN rAF ; tout ce qui n'y passe pas continue pourtant de
       marcher, et le desaccord ne se voit qu'a l'ecran suivant. Une geometrie n'a pas besoin
       d'attendre une frame : on la pose tout de suite, le dessin suivra. */
    poseRapportBoite();
    /* `boutonVue` est declare plus bas : var, donc `undefined` ici et jamais une erreur. On
       REACCORDE un bouton existant, on ne le cree pas : sa creation reste le travail de
       `majBlocs`, qui sait quel type est choisi. */
    if (boutonVue) majBoutonVue();
  }
  /* Le seul endroit qui ecrit la forme de la boite. Trois appelants : la bascule de vue, le
     changement d'option (majBlocs) et le rendu (planifie), qui la reasserte parce que product.js
     peut avoir laisse le rapport d'une photo de galerie sur le wrap. */
  function poseRapportBoite() {
    var r = String(ratioBoite());
    var wrapAcc = document.querySelector(".pdp-gallery__wrap");
    if (wrapAcc) wrapAcc.style.setProperty("--acc-ar", r);
    if (interne) {
      interne.style.setProperty("--art-ratio", r);
      interne.style.setProperty("--acc-ar", r);
    }
  }
  poseVueScene(false);
  function decorDuType() {
    var n = SCENES[etat.type];
    return n ? DECORS[n] : null;
  }
  /* ⛔ LA BOITE PREND LE RAPPORT DE CE QU'ELLE MONTRE. En vue scene elle montre une PHOTO,
     pas le panneau : lui imposer le rapport du produit etirait le decor, et `dessineDansDecor`
     n'a qu'un facteur d'echelle (`k = W / d.W`) parce qu'il compte sur une boite au rapport de
     l'image. Choisir 80 x 120 (0,667 contre 0,692 pour le chevalet) posait le panneau 22 px
     trop haut dans la plaque et laissait une bande blanche en bas, visible a l'ecran
     (08/08/2026). Le decor garde donc SON rapport, et le panneau s'inscrit dedans au sien. */
  function ratioBoite() {
    if (vueScene) { var d = decorDuType(); if (d) return d.W / d.H; }
    return ratioCourant();
  }
  function chargeDecors() {
    if (!zone) return;
    var urls = {};
    try { urls = JSON.parse(zone.getAttribute("data-scenes") || "{}"); } catch (e) { return; }
    Object.keys(DECORS).forEach(function (n) {
      if (imagesDecor[n] || !urls[n]) return;
      var img = new Image();
      img.decoding = "async";
      /* Le canvas sert aussi a fabriquer le fichier d'impression : une image du CDN sans
         crossOrigin le rendrait illisible (tainted) et casserait l'ajout au panier. */
      img.crossOrigin = "anonymous";
      img.onload = function () { planifie(); };
      img.onerror = function () { delete imagesDecor[n]; };
      img.src = urls[n];
      imagesDecor[n] = img;
    });
  }

  /* Le dessin nu, hors ecran, a son vrai rapport. On le fabrique une fois par rendu et on
     l'inscrit ensuite dans la photo : `dessine` n'a pas a savoir qu'une scene existe. */
  var horsEcran = document.createElement("canvas");
  function dessineDansDecor(g, W, H, dpr) {
    var d = decorDuType();
    var img = d && imagesDecor[SCENES[etat.type]];
    if (!d || !img || !img.complete || !img.naturalWidth) return false;

    var k = W / d.W;                       /* un seul facteur : l'image a le rapport du cadre */
    g.drawImage(img, 0, 0, W, H);

    var q = d.quad.map(function (p) { return [p[0] * k, p[1] * k]; });
    var ux = q[1][0] - q[0][0], uy = q[1][1] - q[0][1];   /* le long du bord haut */
    var vx = q[3][0] - q[0][0], vy = q[3][1] - q[0][1];   /* le long du bord gauche */
    var lu = Math.sqrt(ux * ux + uy * uy);
    var lv = Math.sqrt(vx * vx + vy * vy);
    if (lu < 8 || lv < 8) return false;

    /* Le dessin, a son rapport, centre dans le panneau vide.
       ⚠️ DEUX FACONS DE L'Y METTRE, ET LE TYPE TRANCHE. Un panneau de texte s'INSCRIT : ce que
       le dessin ne couvre pas devient un bord de sa propre couleur de fond, ce qui ressemble a
       une marge un peu large et ne coute pas une lettre. Le panneau photo, lui, se REMPLIT :
       une photo plein bord bordee de deux bandes bordeaux n'est pas une photo plein bord. Elle
       deborde donc et se fait rogner, ce qu'un recadrage fait de toute facon. */
    /* ⛔ LE DESSIN OCCUPE TOUT LE PANNEAU DE LA PHOTO, NI PLUS NI MOINS.
       Deux versions ont echoue, et pour la meme raison : LE PANNEAU VIDE DU DECOR N'A PAS LE
       RAPPORT DU PRODUIT. Sa plaque mesure 568 x 991, soit 0,573, quand les quatre cotes
       vendues vont de 0,667 a 0,714.
         · en REMPLISSANT au rapport produit, le dessin debordait en largeur et se faisait
           rogner : « ET MOOISTE JA-WOOR », les deux bords manges (20/08, matin) ;
         · en l'INSCRIVANT, il laissait deux bandes de 90 px en haut et en bas : « de l'espace
           est rajoute en haut et en bas sur le rendu en situation » (20/08, apres-midi).
       Aucun reglage du meme calcul ne pouvait donner les deux a la fois. Le dessin est
       PARAMETRIQUE en W et H : on lui demande donc directement les cotes de la plaque. La
       composition s'y accorde d'elle-meme, rien ne deborde et rien ne flotte.
       ⚠️ CE QUE CELA COUTE, ET C'EST ASSUME : la mise en scene ne montre plus le rapport EXACT
       du produit, elle montre son contenu entier. Le rapport juste, lui, se lit sur l'apercu, ou
       le cadre est aux cotes reelles. Un decor dont la plaque serait photographiee au rapport
       vendu rendrait les deux vrais a la fois. */
    var pw = lu, ph = lv;
    var ox = 0, oy = 0;

    g.save();
    /* Le socle passe devant : on coupe le panneau a sa hauteur plutot que de peindre dessus. */
    if (d.socle) {
      g.beginPath();
      g.rect(0, 0, W, d.socle * k);
      g.clip();
    }
    /* Le fond du panneau d'abord, sur TOUT le quadrilatere : c'est lui qui remplit ce que le
       dessin ne couvre pas, et qui fait disparaitre le blanc de la photo. */
    g.beginPath();
    g.moveTo(q[0][0], q[0][1]);
    g.lineTo(q[1][0], q[1][1]);
    g.lineTo(q[2][0], q[2][1]);
    g.lineTo(q[3][0], q[3][1]);
    g.closePath();
    /* ⚠️ ET LE FOND DE REMPLISSAGE EST CELUI DU DESSIN, PAS CELUI DES FONDS. Le type photo n'a
       pas de fond choisi : `FONDS.blanc.fond` vaut #FBFAF7, un blanc casse, quand `dessinePhoto`
       peint du #FFFFFF. Sur un panneau inscrit, l'ecart se voit en bordure. */
    g.fillStyle = etat.type === "photo" ? "#FFFFFF" : (FONDS[etat.fond] || FONDS.blanc).fond;
    g.fill();
    /* Et le dessin ne sort pas du panneau : le chemin sert de decoupe juste apres avoir servi
       de remplissage. Sans ca, la photo qui deborde peindrait le mur et le pied. */
    g.clip();

    var lpx = Math.max(1, Math.round(pw * dpr));
    if (horsEcran.width !== lpx || horsEcran.height !== Math.round(ph * dpr)) {
      horsEcran.width = lpx; horsEcran.height = Math.max(1, Math.round(ph * dpr));
    }
    var hg = horsEcran.getContext("2d");
    hg.setTransform(dpr, 0, 0, dpr, 0, 0);
    hg.clearRect(0, 0, pw, ph);
    dessine(hg, pw, ph, true);

    /* La bascule vers le panneau : un pas de dessin le long de u, un le long de v. Les bords
       du panneau ne sont pas tout a fait paralleles, mais moins d'un demi-degre les separe :
       une transformation affine suffit, et evite une homographie que le moindre coin mal
       releve trahirait sur le lettrage. */
    var ex = ux / lu, ey = uy / lu;
    var fx = vx / lv, fy = vy / lv;
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.transform(ex, ey, fx, fy, q[0][0] + ox * ex + oy * fx, q[0][1] + ox * ey + oy * fy);
    g.drawImage(horsEcran, 0, 0, pw, ph);
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.restore();

    /* Ce qui passe devant, repris de la photo. */
    (d.devant || []).forEach(function (b) {
      g.drawImage(img, b[0], b[1], b[2], b[3],
                  b[0] * k, b[1] * k, b[2] * k, b[3] * k);
    });
    return true;
  }

  var demande = false;
  function planifie() {
    if (demande) return;
    demande = true;
    requestAnimationFrame(function () {
      demande = false;
      /* Reassertion du rapport en vue panneau : au retour d'une scene, product.js a laisse
         sur le wrap les dimensions de la photo (ou les pose apres coup, si son chargement
         finit tard). Poser le rapport AVANT de mesurer : getBoundingClientRect force la
         mise en page, le canvas est donc mesure dans la bonne boite des cette passe. */
      /* ⚠️ SEULEMENT QUAND LE CANVAS EST DEVANT. Le rapport de la boite appartient a ce qui
         s'affiche : si l'on regarde une photo de la galerie, c'est elle qui l'a pose. */
      if (!scene.hidden) poseRapportBoite();
      var r = scene.getBoundingClientRect();
      if (!r.width) return;
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      if (scene.width !== Math.round(r.width * dpr) || scene.height !== Math.round(r.height * dpr)) {
        scene.width = Math.round(r.width * dpr); scene.height = Math.round(r.height * dpr);
      }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, r.width, r.height);
      /* ⛔ LE PANNEAU PLEIN CADRE PAR DEFAUT, LA SCENE SUR DEMANDE (Adrien, 07/08/2026).
         La scene a d'abord ete la vue de composition. Elle rend le panneau a 65 % de la largeur
         du cadre sur le chevalet, parce qu'un pied pleine hauteur ne se montre pas autrement :
         tout le texte du client rapetissait d'autant, l'anglaise devenait illisible et la date
         un filet gris. On ne compose pas ce qu'on ne lit pas. La scene reste, en vignette de
         tete : un clic l'ouvre en grand, et toucher un reglage ramene au panneau. */
      var enScene = vueScene && dessineDansDecor(ctx, r.width, r.height, dpr);
      if (!enScene) dessine(ctx, r.width, r.height, true);
      /* ⛔ LES COTES MESURENT LE PANNEAU, PAS LA PIECE. Elles encadrent le cadre : tant qu'il
         ne contenait que le panneau, « 50 cm » en haut et « 70 cm » a droite disaient vrai. Le
         cadre montre maintenant une table de banquet ou un chevalet dans un salon, et les memes
         chiffres annoncaient que la piece entiere fait 50 sur 70 (Adrien, 07/08/2026 : « cote
         sur l'image »). On les efface le temps de la scene plutot que de les faire mentir. */
      var cadre = interne.parentElement;
      if (cadre) cadre.setAttribute("data-panneau-scene", enScene ? "1" : "");
      majHauteurBande();
    });
  }
  if (window.ResizeObserver) new ResizeObserver(planifie).observe(interne);
  window.addEventListener("resize", planifie);

  /* La demo du panneau photo : le visuel d'exemple, apercu seulement (jamais imprime :
     l'ajout du type photo exige la photo de la cliente). */
  function redessineCartesType() {
    planifie(); majVignettes();
    /* La carte du type photo se redessine avec la demo arrivee. */
    if (!barreTypes) return;
    Array.prototype.forEach.call(barreTypes.querySelectorAll("button"), function (b) {
      var id = TYPES[b.getAttribute("data-panneau-type")];
      var c = b.querySelector("canvas");
      if (!id || !c) return;
      var sauve = JSON.parse(JSON.stringify(etat));
      etat.type = id;
      dessine(c.getContext("2d"), c.width, c.height, true);
      Object.keys(etat).forEach(function (k) { etat[k] = sauve[k]; });
    });
  }
  (function () {
    [["data-demo-photo", function (o) { demoPhoto = o; }],
     ["data-demo-photo-couleur", function (o) { demoPhotoCouleur = o; }]].forEach(function (p) {
      var u = zone.getAttribute(p[0]);
      if (!u) return;
      var img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = function () {
        p[1]({ bmp: img, w: img.naturalWidth, h: img.naturalHeight });
        redessineCartesType();
      };
      img.src = u;
    });
  })();

  /* ---- Vignettes : des exemples DU TYPE COURANT, mini-rendus du meme dessin ----
     Cliquer une vignette applique son option (fond ou style) : l'exemple est l'action. */
  var thumbs = document.getElementById("pdp-thumbs");
  /* ⛔ LA BANDE NE MONTRE QUE LES MISES EN SCENE (Adrien, 07/08/2026 : « il ne faut pas
     afficher aussi les images placeholders dans la galerie, uniquement les images que je t'ai
     donnees »). Elle posait quatre mini-rendus du configurateur, un par couleur de fond : un
     doublon du nuancier qui est deja dans la colonne d'achat, et surtout des dessins au milieu
     de photographies, ce qui faisait passer les vraies mises en scene pour des maquettes.
     La fonction ne fait donc plus que RETIRER ce qu'une version precedente avait pu poser ;
     elle reste appelee de partout, il n'y a rien a debrancher ailleurs. */
  function majVignettes() {
    if (!thumbs) return;
    Array.prototype.forEach.call(thumbs.querySelectorAll(".panneau-thumb"), function (v) {
      if (v.parentNode) v.parentNode.removeChild(v);
    });
  }

  /* ---- Le H1 et les blocs suivent le type ---- */
  var h1 = document.getElementById("pdp-title");
  function majH1() {
    if (!h1) return;
    var lib = etat.type === "plan" ? T.h1_plan
      : etat.type === "bar" ? T.h1_bar
      : etat.type === "voiture" ? T.h1_voiture
      : etat.type === "photo" ? T.h1_photo : T.h1_bienvenue;
    if (!lib) return;
    h1.textContent = lib;
    /* ⛔ LE <title> SUIT LE H1 (serie 109). L'audit d'atterrissage du 12/08 : le clic d'une
       annonce « Sitzplan Hochzeit » ouvrait un onglet nomme « Personalisiertes
       Willkommensschild Hochzeit », le seul texte de la page qui ne suivait pas la variante.
       Le suffixe boutique reste en place ; son separateur (demi-cadratin) est deja dans le
       title rendu, la regle du depot interdit d'ecrire ce caractere, d'ou fromCharCode. */
    var sep = " " + String.fromCharCode(8211) + " ";
    var iSep = document.title.indexOf(sep);
    document.title = lib + (iSep >= 0 ? document.title.slice(iSep) : "");
  }
  /* ⛔ LA LIGNE DE VALEUR DOIT SUIVRE LE TYPE. Elle est ecrite par Liquid pour LE PANNEAU, au
     singulier : « jusqu'au 100 x 140 cm », « il tient seul sur un chevalet, ou se suspend a une
     arche ». Trois phrases fausses sur le panneau voiture, qui ne se vend qu'en 50 x 35, ne
     tient sur rien et s'accroche a une voiture. Le serveur ne peut pas trancher, il ne connait
     pas le type choisi : c'est ici que ca se decide, et chaque paragraphe reste un paragraphe
     (le separateur est la barre, comme cote Liquid). */
  var boiteEntites = document.createElement("textarea");
  function decodeEntites(t) { boiteEntites.innerHTML = String(t); return boiteEntites.value; }
  function majLigneValeur() {
    var bloc = document.getElementById("perso-value-line");
    if (!bloc) return;
    var brut = etat.type === "voiture" ? T.valeur_voiture : T.valeur_panneau;
    if (!brut) return;
    /* ⚠️ LES ENTITES SONT DECODEES AVANT D'ETRE POSEES EN TEXTE. Le filtre de traduction rend
       une chaine deja echappee pour le HTML : « l&#39;arriere ». Liquid l'ecrit dans la page et
       le navigateur la decode, mais `textContent` l'affiche telle quelle, apostrophe comprise.
       Le decodage passe par un `textarea`, dont le contenu n'est jamais analyse comme des
       elements : rien de ce que porte une traduction ne peut devenir une balise. */
    var bouts = String(brut).split("|").map(function (x) { return decodeEntites(x.trim()); }).filter(Boolean);
    bloc.innerHTML = "";
    bouts.forEach(function (b) {
      var p = document.createElement("p");
      p.textContent = b;
      bloc.appendChild(p);
    });
  }

  /* ⛔ LA GALERIE NE MONTRE QUE LES IMAGES DU TYPE CHOISI (Adrien, 07/08/2026). Les vignettes
     sont marquees et deja filtrees par le gabarit, d'apres la variante preselectionnee : ici on
     ne fait que suivre les changements de type.
     ⚠️ ET ON NE TOUCHE A LA VUE PRINCIPALE QUE SI ELLE DISPARAIT. Cliquer une vignette a chaque
     bascule ramenerait le client sur une photo alors qu'il regardait son propre panneau se
     composer. On ne bouge que si la vignette pressee vient d'etre masquee ; et si le nouveau
     type n'a aucune mise en scene, on revient sur l'apercu du configurateur plutot que de
     laisser une image d'un autre type a l'ecran. */
  /* ⛔ L'APERCU VIVANT COUVRE LA SCENE, ET C'EST BIEN CE QU'ON VEUT SAUF ICI. Le canvas est
     pose DANS `.pdp-frame__inner`, par-dessus l'image de la galerie : cliquer une mise en scene
     changeait donc l'image du dessous sans que rien ne se voie. On efface le canvas le temps
     qu'une photo soit regardee, et on le remet des qu'un reglage est touche. */
  function montreApercu(oui) {
    if (!scene) return;
    scene.hidden = !oui;
    if (oui) planifie();
  }
  /* ⛔ TOUCHER UN REGLAGE RAMENE L'APERCU, PAS LA VUE A PLAT (Adrien, 08/08/2026 : « quand on
     clique sur voir en situation, puis que l'on change de couleur (ou n'importe quelle autre
     option), on quitte la vue en situation »).
     Deux etats bien distincts vivaient dans la meme ligne :
     - `montreApercu` dit si le CANVAS est devant ou si l'on regarde une photo de la galerie ;
     - `vueScene` dit CE QUE le canvas peint, le panneau nu ou le panneau dans son decor.
     Toucher un reglage doit ramener le canvas (sinon on compose a l'aveugle derriere une photo
     de la galerie) : ca, c'est `montreApercu(true)`, et ca reste. Mais ca ne dit rien du decor.
     Le retour au panneau nu avait ete accroche la en 07/2026 parce que le bouton n'existait pas
     encore et qu'il fallait bien un chemin de retour ; le bouton EST ce chemin depuis. La scene
     est vivante : elle se repeint a chaque frappe, la couleur et le lettrage changent dedans.
     Il n'y a donc aucune raison d'en sortir le client. */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest("[data-panneau-vue]")) { poseVueScene(true); montreApercu(true); planifie(); return; }
    if (t.closest("[data-panneau-media] .pdp-thumb")) { montreApercu(false); return; }
    if (t.closest("#panneau-zone") || t.closest("#panneau-types")) { montreApercu(true); planifie(); }
  }, true);
  ["input", "change"].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var t = e.target;
      if (t && t.closest && t.closest("#panneau-zone")) { montreApercu(true); planifie(); }
    }, true);
  });

  /* La vignette de tete : la scene, en petit. Elle porte la photo du decor telle quelle, sans
     le dessin ; c'est la vue en grand qui est vivante. Elle prend la classe `pdp-thumb` pour
     avoir l'allure des autres et pour que product.js gere son cadre presse, mais elle n'a ni
     `data-img` ni `data-zoom` : rien a poser derriere, le canvas s'en charge. */
  function vignetteScene() {
    /* ⛔ PLUS DE VIGNETTE « EN SITUATION » (Adrien, 08/08/2026 : « vire en situation des
       thumbnails de tous les types »). Le meme geste vit sous l'image (majBoutonVue) ; la
       vignette doublonnait et lisait comme une image cassee. On retire celle qu'une version
       precedente aurait posee, et on n'en cree plus. */
    if (!thumbs) return;
    var it = thumbs.querySelector("[data-panneau-vue]");
    if (it) it.remove();
  }

  /* Le meme geste, sous l'image (Adrien, 07/08/2026 : « ajoute un bouton en bas de l'image pour
     voir le placeholder en situation »). La vignette de tete se voit du coin de l'oeil ; sous
     l'apercu, la bascule se trouve la ou le regard est deja. Le libelle dit ou l'on VA, pas ou
     l'on est : c'est ce qu'on lit sur un bouton. */
  /* ⛔ DANS L'IMAGE, EN BAS, COMME LES PASTILLES DE MUR (Adrien, 08/08/2026 : « le bouton
     "Voir en situation" est invisible a cause de la taille de l'image et de l'espace sur la
     version panneau. Il faut probablement le mettre dans l'image en bas, comme les pastilles de
     couleur »). Il etait pose APRES `#pdp-stage`, et le stage est plus haut que le panneau : la
     hauteur du stage vient du rapport a 100 % de la largeur, celle du panneau de `width:85%`.
     Sur un 1512 x 828 le panneau finissait a 1 028, le stage a 1 170, le bouton a 1 180. La
     galerie etant epinglee, AUCUNE position de defilement ne le faisait entrer dans l'ecran :
     invisible, pas discret. Dans le cadre il ne peut plus se detacher de ce qu'il commande. */
  var boutonVue = null;
  function majBoutonVue() {
    var cadre = document.getElementById("pdp-frame");
    if (!cadre) return;
    if (!decorDuType()) { if (boutonVue) boutonVue.hidden = true; return; }
    if (!boutonVue) {
      boutonVue = document.createElement("button");
      boutonVue.type = "button";
      boutonVue.className = "panneau-vue sans";
      boutonVue.addEventListener("click", function () {
        poseVueScene(!vueScene);
        montreApercu(true);
        planifie();
      });
    }
    /* Le cadre est refait par product.js selon la vue : on se replace a chaque passage. */
    if (boutonVue.parentElement !== cadre) cadre.appendChild(boutonVue);
    boutonVue.hidden = false;
    /* Le libelle dit ou l'on VA, jamais ou l'on est : c'est ce qu'on lit sur un bouton. */
    boutonVue.textContent = vueScene
      ? (T.vue_panneau || "Voir mon panneau")
      : (T.vue_scene || "Voir en situation");
    boutonVue.setAttribute("aria-pressed", vueScene ? "true" : "false");
  }

  /* ⛔ LA BANDE NE DEPASSE PAS L'IMAGE (Adrien, 07/08/2026 : « la galerie est trop haute sur
     desktop »). La borne ne peut pas se poser en CSS : la colonne des vignettes couvre quatre
     rangees de la grille, donc son aire est bien plus haute que la scene, et `max-height:100%`
     s'y resout sans rien borner. Seule la hauteur mesuree de la scene fait la regle, et elle
     change avec le format choisi comme avec la largeur de la fenetre. */
  /* ⛔ UN `max-height` SANS DEBORDEMENT NE COUPE RIEN, IL FAIT DEBORDER. C'est ce que faisait
     cette fonction : la bande annoncait la hauteur de l'affiche, et ses deux dernieres
     vignettes se peignaient dessous, hors de sa boite, par-dessus ce qui suit. La galerie
     mesurait donc moins haut qu'elle ne se voyait. Le repli en deux colonnes de product.js
     regle le meme probleme sans rien deplacer ni cacher ; on l'appelle, et le nombre de
     vignettes ayant change avec le type de panneau, on le rappelle a chaque changement. */
  function majHauteurBande() {
    if (thumbs) thumbs.style.maxHeight = "";
    if (window.__pdpMajBande) window.__pdpMajBande();
  }

  function majGalerieType() {
    var items = document.querySelectorAll("[data-panneau-media]");
    if (!items.length) return;
    var presseMasque = false, premier = null;
    Array.prototype.forEach.call(items, function (it) {
      var ok = it.getAttribute("data-panneau-media") === etat.type;
      it.hidden = !ok;
      var b = it.querySelector(".pdp-thumb");
      if (!ok && b && b.getAttribute("aria-pressed") === "true") presseMasque = true;
      if (ok && !premier) premier = it;
    });
    if (!presseMasque) return;
    /* On repositionne la vignette pressee sur le bon type, pour que la bande reste coherente.
       ⛔ MAIS L'APERCU RESTE DEVANT, TOUJOURS. Il passait a `false` ici : arriver sur la fiche
       par ?variant= d'un type autre que le premier (les cartes de collection font exactement
       ca) masquait l'apercu, et le clic programme sur la vignette ne posait aucune image
       derriere puisque product.js n'avait pas encore pris la main. Le client tombait sur un
       RECTANGLE VIDE au lieu de son panneau (07/08/2026). Effacer l'apercu ne se justifie que
       quand c'est LUI qui clique une mise en scene, pas quand le type change sous ses yeux. */
    var cible = premier && premier.querySelector(".pdp-thumb");
    if (cible) cible.click();
    montreApercu(true);
  }

  function majBlocs() {
    /* ⛔ ET LE TYPE PEUT N'AVOIR AUCUNE SCENE. On resterait alors « en situation » devant un
       panneau nu, avec un bouton masque pour en sortir : la vue se rend en meme temps que le
       decor qui la justifie. */
    if (vueScene && !decorDuType()) poseVueScene(false);
    /* La forme de la boite : `--art-ratio` sur l'inner (il porte l'`aspect-ratio`) et `--acc-ar`
       sur le WRAP, jamais seulement sur l'inner. La regle CSS lit `--acc-ar` sur `#pdp-stage`,
       et une variable posee sur un DESCENDANT lui est invisible : le stage gardait le rapport
       que product.js ecrit sur le wrap au chargement de chaque photo de scene (900/900 pour la
       premiere scene voiture), et le panneau restait carre quel que soit le type (Adrien,
       07/08/2026, deux fois). */
    poseRapportBoite();
    majLigneValeur();
    majGalerieType();
    /* Chaque type a sa scene : la vignette de tete et le bouton suivent le type. */
    vignetteScene(); majBoutonVue(); majHauteurBande();
    /* Le panneau photo est le seul type qui attend une photo : la rangee d'achat doit le
       reapprendre a chaque bascule, sinon le CTA reste celui du type precedent. */
    if (window.__pdpMajRangeeAchat) window.__pdpMajRangeeAchat();
    /* La perforation est D'ORIGINE sur le panneau voiture (Adrien, 07/08/2026) : deux
       oeillets aux coins hauts pour le ruban, compris dans les 45 euros. La case de l'upsell
       n'a donc pas de sens ici, et l'etat est force pour que la bonne variante parte. */
    var upsellPerfo = document.getElementById("pdp-up-perfo");
    if (etat.type === "voiture") {
      etat.perfo = true;
      if (upsellPerfo) upsellPerfo.hidden = true;
    } else {
      /* ⛔ ET ON RELACHE EN SORTANT (Adrien, 08/08/2026, audit de la fiche). `etat.perfo`
         restait a `true` en quittant le panneau voiture, et il est persiste : la case revenait
         cochee sur tous les autres types, a la visite comme au rechargement, la variante
         partait en « Perforation », et le client payait 5 EUR qu'il n'avait jamais demandes.
         L'etat force ne vaut que pour ce type ; ailleurs c'est le choix du client qui fait foi. */
      etat.perfo = etat.perfoClient;
      var casePerfo = document.getElementById("pdp-up-perfo-check");
      if (casePerfo && casePerfo.checked !== etat.perfo) casePerfo.checked = etat.perfo;
      if (upsellPerfo) upsellPerfo.hidden = false;
    }
    /* La finition retenue redescend dans product.js, qui choisit la variante et ecrit le prix.
       Sans ce pont, une perforation imposee par le type (le panneau voiture) restait invisible
       de lui, et il cherchait une combinaison qui n'existe pas. */
    if (window.__pdpPanneauFinition) window.__pdpPanneauFinition(etat.perfo);
    var t = etat.type;
    var montre = {
      entete: t === "bienvenue",
      voiture: t === "voiture",
      /* L'esperluette, les prenoms et la date servent les DEUX pieces du meme mariage. */
      esperluette: t === "bienvenue" || t === "voiture",
      prenoms: t === "bienvenue" || t === "voiture",
      lieu: t === "bienvenue",
      plan: t === "plan",
      bar: t === "bar",
      fond: etat.type !== "photo",
      police: etat.type !== "photo" || avecTexte(),
      style: etat.type === "photo",
      rendu: etat.type === "photo",
      legende: etat.type === "photo" && avecTexte(),
      sousstyle: etat.type === "photo" && avecTexte(),
      legdate: etat.type === "photo" && etat.style === "centre"
    };
    Array.prototype.forEach.call(zone.querySelectorAll("[data-panneau-bloc]"), function (b) {
      b.hidden = !montre[b.getAttribute("data-panneau-bloc")];
    });
    /* La zone d'import perso ne vaut que pour le panneau photo. */
    var drop = document.querySelector(".perso-drop");
    if (drop) drop.hidden = etat.type !== "photo";
    var qc = document.getElementById("pdp-qc");
    if (qc && etat.type !== "photo") qc.hidden = true;
  }

  /* ---- Prix sous les tailles : ceux du type courant (sans perforation) ---- */
  function typeValeur(id) {
    var i = SLUGS.indexOf(id || etat.type);
    return i < 0 ? VALEURS[0] : VALEURS[i];
  }
  function majPrixTailles() {
    var grp = document.querySelector('[data-option-index="1"]');
    if (!grp) return;
    var variantes = window.__pdpVariants || [];
    Array.prototype.forEach.call(grp.querySelectorAll("[data-value]"), function (pill) {
      var taille = pill.getAttribute("data-value");
      var duType = variantes.filter(function (x) {
        return x.option1 === typeValeur() && x.option2 === taille;
      });
      /* Le prix affiche est celui SANS perforation, la finition de base. Le panneau voiture
         n'a pas de version sans : sa perforation est d'origine, on prend donc sa seule
         variante plutot que de laisser la pilule sans prix.
         ⛔ « sans » ne se cherche plus dans le mot : traduit, il devient « Zonder ogen »,
         « Bez przelotek », « Χωρίς κρίκους ». La finition de base est la premiere valeur. */
      var v = duType.filter(function (x) { return x.option3 === FIN[0]; })[0] || duType[0];
      /* ⛔ UNE TAILLE SANS VARIANTE POUR CE TYPE NE S'AFFICHE PAS. Le 50 x 35 n'existe que
         sur le panneau voiture, et les quatre portraits n'existent pas sur lui : laisser la
         pilule visible proposerait un format qu'aucune variante ne sait vendre, avec le prix
         du type precedent encore ecrit dessous. */
      pill.hidden = !duType.length;
      var s = pill.querySelector("small");
      /* La pilule du 50 x 35 sort du gabarit SANS son `small` : Liquid ne l'ecrit que pour
         les tailles qui avaient un prix au rendu, et cette taille-la n'existait pas encore.
         On le cree plutot que de laisser un format sans prix. */
      if (v && !s) { s = document.createElement("small"); pill.appendChild(s); }
      if (v && s) {
        var cents = v.price;
        s.textContent = (cents / 100).toFixed(2).replace(".", ",") + " €";
      }
    });
    /* ⛔ ET LA TAILLE CHOISIE DOIT EXISTER DANS LE NOUVEAU TYPE. En passant du panneau de
       bienvenue au panneau voiture, le 50 x 70 reste presse alors qu'aucune variante ne le
       porte : l'ajout au panier partait sur une combinaison introuvable. On repli sur la
       premiere taille visible du type. */
    var presse = grp.querySelector('[data-value][aria-pressed="true"]');
    if (presse && presse.hidden) {
      var premiere = grp.querySelector('[data-value]:not([hidden])');
      if (premiere) premiere.click();
    }
    /* ⛔ UNE SEULE TAILLE N'EST PAS UN CHOIX (Adrien, 07/08/2026 : « les tailles n'ont aucun
       sens pour un panneau a l'arriere d'une voiture »). Le panneau voiture n'existe qu'en
       50 x 35 : lui laisser un selecteur de taille, un titre et un guide des tailles fait
       poser une question qui n'a qu'une reponse. On retire le bloc, et on presse la seule
       taille a sa place : sans ca l'ajout au panier resterait bloque sur « Choisir un format ».
       La cote est dite dans le texte de la fiche, ou elle informe au lieu de demander. */
    var visibles = grp.querySelectorAll('[data-value]:not([hidden])');
    var bloc = grp.parentElement;
    if (bloc) bloc.style.display = visibles.length <= 1 ? "none" : "";
    if (visibles.length === 1 && visibles[0].getAttribute("aria-pressed") !== "true") visibles[0].click();
  }

  /* ---- CTA : l'import de photo tant que le panneau photo n'a pas la sienne ---- */
  var boutonAdd = document.getElementById("pdp-add");
  /* ⛔⛔ ET LE BOUTON DIT « VOIR LE RENDU » QUAND C'EST CE QU'IL FAIT (Adrien, 21/08/2026 : « il
     n'y a pas "voir le rendu" comme les autres mais "ajout au panier" »).
     Sur telephone, un clic sur ce bouton OUVRE LA FENETRE DE RENDU : l'interception est posee
     plus bas, en capture, depuis le 20/08. Le libelle, lui, n'avait jamais suivi : le panneau
     n'avait pas l'equivalent du `majCtaRendu` du pele-mele, si bien que le bouton continuait
     d'annoncer « Ajouter au panier » pour un clic qui n'ajoutait rien. Un bouton qui fait autre
     chose que ce qu'il dit se paie deux fois : le client hesite, puis il se croit trompe.
     ⚠️ L'IMPORT PASSE DEVANT. Tant qu'une photo est exigee et absente, c'est CE manque-la qu'il
     faut dire, pas ce que le bouton fera plus tard. */
  function majCta() {
    var importer = T.importer || "Importer ma photo";
    var attendPhoto = etat.type === "photo" && !photo;
    var viaModale = !!(window.murEstMobile && window.murEstMobile());
    var voir = T.voir_rendu || "Voir le rendu";
    /* ⛔⛔ ET LA PORTE S'OUVRE DANS LES DEUX SENS. L'ancienne version ecrivait le libelle d'import
       quand la photo manquait, et NE REECRIVAIT RIEN quand elle arrivait : son commentaire disait
       « product.js vient d'ecrire son libelle, on le laisse », ce qui n'est vrai qu'au moment
       d'un changement de prix. Au retour de session, la photo est restauree en ASYNCHRONE : le
       bouton avait deja recu « Importer ma photo » a l'init, `restaurePhoto` appelle `majCta`
       une fois l'image chargee, et rien ne mettait le mot d'achat a la place. Le client voyait
       donc « Importer ma photo » avec sa photo deja en place et son bouton « Changer la photo »
       juste au-dessus (Adrien, 21/08/2026 : « je vois importer la photo alors que j'ai deja
       importe »). Un etat qui ne sait qu'entrer n'est pas un etat, c'est une impasse. */
    var prixQueue = function (t) {
      var i = t.indexOf(" · ");
      if (i >= 0) return t.slice(i);
      /* Le libelle d'import a remplace le texte ENTIER, prix compris : on le refabrique depuis
         la variante courante, avec le formateur du site et pas un second. */
      var v = varianteCourantePanneau();
      if (!v || typeof window.MURMURE_MONEY !== "function") return "";
      return " · " + window.MURMURE_MONEY(v.price);
    };
    var libelle = function (el, mot) {
      if (!el || !mot) return;
      var t = el.textContent || "";
      var i = t.indexOf(" · ");
      var tete = i >= 0 ? t.slice(0, i) : t;
      /* ⚠️ ON N'ECRIT QUE SI LA TETE DIFFERE. Le bouton porte parfois un ancien prix barre en
         `<s>` : le reecrire a chaque passage l'aplatirait en texte et ferait disparaitre la
         remise. Tant que le mot est le bon, on ne touche a rien. */
      if (tete === mot) return;
      el.textContent = mot + prixQueue(t);
    };
    /* ⛔ LE LIBELLE DU PANIER VIENT DU THEME, ET IL N'EST ECRIT QUE SUR LA BARRE COLLEE.
       `#pdp-add` n'a pas de `data-label-add` : le lire sur lui rendait une chaine vide, donc
       aucune ecriture, donc le libelle d'import restait en place sur le bouton de la page,
       c'est-a-dire exactement le defaut qu'on repare. C'est la meme lecon que le pele-mele le
       20/08 : la vraie phrase, traduite, vit a UN endroit, et les deux boutons la lisent la. */
    var motAjout = function () {
      var st = document.getElementById("pdp-sticky-add");
      return (st && st.getAttribute("data-label-add"))
        || (boutonAdd && boutonAdd.getAttribute("data-label-add")) || "";
    };
    var motDu = function (el) {
      if (attendPhoto) return el.getAttribute("data-label-perso") || importer;
      if (viaModale) return voir;
      return motAjout();
    };
    if (boutonAdd) {
      if (attendPhoto) boutonAdd.textContent = motDu(boutonAdd);
      else libelle(boutonAdd, motDu(boutonAdd));
    }
    var colle = document.getElementById("pdp-sticky-add");
    if (colle) {
      if (attendPhoto) colle.textContent = motDu(colle);
      else libelle(colle, motDu(colle));
    }
  }
  window.__pdpPanneauMajCta = majCta;
  /* ⛔ UN SEUL DES CINQ TYPES ATTEND UNE PHOTO, ET product.js NE POUVAIT PAS LE SAVOIR. Il
     range la fiche perso par sa CLASSE : `.pdp--perso` sans `.pdp--perso-has-photo` veut dire
     « rien a vendre tant qu'aucune photo n'est posee », donc il masque le bouton d'achat et
     met « Importer ma photo » a sa place. La fiche panneau porte la meme classe parce qu'elle
     partage le gabarit, et personne n'y pose jamais `-has-photo` : le panneau de bienvenue, le
     plan de table, la carte du bar et le panneau voiture N'AVAIENT AUCUN BOUTON D'ACHAT, ni
     dans la page ni dans la barre collee (elle observe le bouton masque, donc sans boite, donc
     elle ne sortait jamais non plus). Quatre types sur cinq etaient invendables.
     La question n'est pas « quelle fiche est-ce » mais « une photo est-elle exigee MAINTENANT » :
     c'est le configurateur qui le sait, il le dit. */
  window.__pdpExigePhoto = function () { return etat.type === "photo" && !photo; };

  /* ---- Import de la photo (le funnel perso : #pdp-file, cede par product.js) ---- */
  var fichierInput = document.getElementById("pdp-file");
  function chargePhoto(f) {
    var url = URL.createObjectURL(f);
    function parImage() {
      return new Promise(function (res, rej) {
        var img = new Image();
        img.onload = function () { res({ bmp: img, w: img.naturalWidth, h: img.naturalHeight }); };
        img.onerror = rej;
        img.src = url;
      });
    }
    if (!window.createImageBitmap) return parImage();
    return createImageBitmap(f, { imageOrientation: "from-image" })
      .catch(function () { return createImageBitmap(f); })
      .then(function (bmp) { return { bmp: bmp, w: bmp.width, h: bmp.height }; })
      .catch(parImage);
  }
  function envoiFondPhoto(f) {
    var endpoint = window.__persoUpload;
    if (!endpoint) return;
    /* L'evenement d'import doit porter l'image (patron pele) : on attend le depot
       jusqu'a 12,5 s, puis on se resout a compter l'import sans elle. */
    if (window.__persoFunnel) (function attendDepot(restants) {
      if (photoDistante || restants <= 0) {
        window.__persoFunnel("import", photoDistante || "");
        return;
      }
      setTimeout(function () { attendDepot(restants - 1); }, 2500);
    })(5);
    fetch(endpoint, { method: "POST", headers: { "Content-Type": f.type }, body: f })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j && j.url) {
          photoDistante = j.url;
          etat.photoUrl = j.url;
          etat.photoPreview = j.preview || j.url;
          persiste();
        }
      })
      .catch(function () {});
  }
  fichierInput && fichierInput.addEventListener("change", function (e) {
    var f = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!f) return;
    /* ⚠️ PAS `perso_bad_type` ICI : ce message conseille un PDF, que le champ du panneau refuse
       (accept sans application/pdf). Le client qui suivait le conseil echouait une deuxieme
       fois, en croyant que le site etait casse. Un seul fichier a la fois sur cette surface,
       donc le refus se voit toujours : c'est le TEXTE qui etait faux, pas le declenchement. */
    if (!/^image\/(jpeg|png)$/.test(f.type)) {
      if (window.murToast) window.murToast(TI.perso_bad_type_photo || "Format non accepté : importez un JPG ou un PNG");
      return;
    }
    chargePhoto(f).then(function (p) {
      photo = p;
      envoiFondPhoto(f);
      var bloc = document.getElementById("pdp-photo-block");
      var zoneD = document.getElementById("pdp-upload");
      if (bloc) bloc.hidden = false;
      if (zoneD) zoneD.hidden = true;
      var mini = document.getElementById("pdp-photo-thumb");
      if (mini && p.bmp) {
        var c = document.createElement("canvas");
        c.width = 96; c.height = 96;
        poseCover(c.getContext("2d"), p.bmp, p.w, p.h, 0, 0, 96, 96, false);
        mini.style.backgroundImage = "url('" + c.toDataURL("image/jpeg", 0.8) + "')";
      }
      planifie(); majVignettes(); majCta();
      if (window.__pdpRemonteOptions) window.__pdpRemonteOptions();
    });
  });
  var boutonReset = document.getElementById("pdp-photo-reset");
  boutonReset && boutonReset.addEventListener("click", function () {
    photo = null; photoDistante = null;
    etat.photoUrl = ""; etat.photoPreview = ""; persiste();
    var bloc = document.getElementById("pdp-photo-block");
    var zoneD = document.getElementById("pdp-upload");
    if (bloc) bloc.hidden = true;
    if (zoneD) zoneD.hidden = false;
    planifie(); majCta();
    if (fichierInput) fichierInput.click();
  });

  /* ---- Les controles du configurateur ---- */
  function synchronisePilules() {
    Array.prototype.forEach.call(zone.querySelectorAll("[data-panneau-fond]"), function (b) {
      var on = b.getAttribute("data-panneau-fond") === etat.fond;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
    Array.prototype.forEach.call(zone.querySelectorAll("[data-panneau-style]"), function (b) {
      var on = b.getAttribute("data-panneau-style") === etat.style;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
    /* La pilule « Avec texte » n'a pas de valeur a elle : elle est allumee des qu'un des styles
       de la famille est choisi, et « Plein bord » s'eteint alors tout seul par la boucle ci-dessus. */
    Array.prototype.forEach.call(zone.querySelectorAll("[data-panneau-texte]"), function (b) {
      b.classList.toggle("is-on", avecTexte());
      b.setAttribute("aria-pressed", avecTexte() ? "true" : "false");
    });
    Array.prototype.forEach.call(zone.querySelectorAll("[data-panneau-rendu]"), function (b) {
      var on = b.getAttribute("data-panneau-rendu") === (etat.rendu === "nb" ? "nb" : "couleur");
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  var dernierTexte = avecTexte() ? etat.style : "editoriale";
  zone.addEventListener("click", function (e) {
    var b = e.target && e.target.closest ? e.target.closest("[data-panneau-fond],[data-panneau-style],[data-panneau-texte],[data-panneau-rendu]") : null;
    if (!b) return;
    if (b.hasAttribute("data-panneau-fond")) etat.fond = b.getAttribute("data-panneau-fond");
    if (b.hasAttribute("data-panneau-style")) etat.style = b.getAttribute("data-panneau-style");
    /* ⚠️ « Avec texte » NE RAMENE PAS AU PREMIER DES DEUX STYLES. Revenir de « Plein bord » vers
       la famille doit rendre le style qu'on y avait choisi, sinon un aller-retour efface un
       reglage sans que rien ne le dise. */
    if (b.hasAttribute("data-panneau-texte") && !avecTexte()) etat.style = dernierTexte;
    if (avecTexte()) dernierTexte = etat.style;
    if (b.hasAttribute("data-panneau-rendu")) etat.rendu = b.getAttribute("data-panneau-rendu");
    /* ⛔ LES PASTILLES SE REPEIGNENT ICI AUSSI, ET C'EST LE FOND QUI L'EXIGE. `encreDefaut()`
       depend du FOND et du TYPE : sans ce rappel, choisir un fond bordeaux laissait les pastilles
       sur le bleu nuit du fond precedent pendant que l'apercu ecrivait en creme (Adrien,
       20/08/2026). Une pastille qui ment sur la couleur envoyee est pire qu'une pastille absente,
       et c'est la TROISIEME fois que ce meme defaut revient par une porte differente. */
    synchronisePilules(); majBlocs(); persiste(); planifie(); majVignettes();
    majPastilles(); majPastillesPolice();
  });
  /* ⛔ L'OEIL A SON PROPRE ECOUTEUR, PAS UN `closest` DE PLUS DANS CELUI DES PILULES : il ne
     change ni style ni fond, et le passer par la meme branche appellerait `majVignettes()` a
     chaque bascule, donc redessinerait les cinq miniatures de types pour rien. */
  zone.addEventListener("click", function (e) {
    var o = e.target && e.target.closest ? e.target.closest("[data-panneau-oeil]") : null;
    if (!o) return;
    var cle = o.getAttribute("data-panneau-oeil");
    var on = o.getAttribute("aria-pressed") === "true";
    o.setAttribute("aria-pressed", on ? "false" : "true");
    if (on) delete etat.masques[cle]; else etat.masques[cle] = true;
    persiste(); planifie();
  });
  /* Au rechargement, les oeils reprennent l'etat garde en session. */
  Array.prototype.forEach.call(zone.querySelectorAll("[data-panneau-oeil]"), function (o) {
    o.setAttribute("aria-pressed", masque(o.getAttribute("data-panneau-oeil")) ? "true" : "false");
  });
  [["panneau-entete", "entete"], ["panneau-prenoms", "prenoms"], ["panneau-date", "date"],
   ["panneau-lieu", "lieu"],
   ["panneau-tables", "tables"], ["panneau-bar", "bar"], ["panneau-voiture", "voiture"],
   ["panneau-ed-titre", "edTitre"], ["panneau-ed-sous", "edSous"], ["panneau-ed-date", "date"]]
    .forEach(function (paire) {
      var el = document.getElementById(paire[0]);
      if (!el) return;
      el.value = etat[paire[1]] || "";
      el.addEventListener("input", function () {
        etat[paire[1]] = el.value;
        /* ⛔ DEUX CHAMPS POUR UNE SEULE VALEUR : la date se saisit sous le panneau de bienvenue
           ET sous le style centre du panneau photo, et c'est la MEME date. Sans cette recopie,
           taper dans l'un laissait l'autre sur son ancienne valeur : le client voyait sa date
           changer en changeant de type, sans avoir rien touche. */
        Array.prototype.forEach.call(zone.querySelectorAll('[data-panneau-jumeau="' + paire[1] + '"]'),
          function (autre) { if (autre !== el) autre.value = el.value; });
        persiste(); planifie();
      });
    });

  /* ---- Le type : des CARTES en tete de zone, comme la Mise en page du pele-mele.
     Meme gabarit (.pelemele-gabarit, vignette + libelle), vignettes = miniatures du
     VRAI dessin de chaque type. La ligne d'option Type n'existe plus : les cartes
     ecrivent la selection dans product.js (__pdpPanneauType). ---- */
  function majType(valeur) {
    var id = TYPES[valeur];
    if (!id || etat.type === id) return;
    etat.type = id;
    if (window.__pdpPanneauType) window.__pdpPanneauType(valeur);
    persiste(); majH1(); majBlocs(); majPrixTailles(); planifie(); majVignettes(); majCta(); majBarreTypes();
    majPastilles(); majPastillesPolice();
    majUrl();
  }
  var barreTypes = document.getElementById("panneau-types");
  function majBarreTypes() {
    if (!barreTypes) return;
    Array.prototype.forEach.call(barreTypes.querySelectorAll("button"), function (b) {
      var on = TYPES[b.getAttribute("data-panneau-type")] === etat.type;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  function vignetteType(id) {
    /* ⛔ LA VIGNETTE PREND LE SENS DE SON TYPE. Une largeur et une hauteur en dur dessinaient
       le panneau voiture, paysage, dans un rectangle portrait : le texte s'y ecrasait. La
       vignette garde donc la meme HAUTEUR pour que les cinq cartes s'alignent, et sa largeur
       suit le ratio du type. */
    var c = document.createElement("canvas");
    c.height = 98; c.width = Math.round(98 * ratioDe(id));
    var sauve = JSON.parse(JSON.stringify(etat));
    etat.type = id;
    dessine(c.getContext("2d"), c.width, c.height, true);
    Object.keys(etat).forEach(function (k) { etat[k] = sauve[k]; });
    return c;
  }
  (function () {
    if (!barreTypes) return;
    /* ⛔ LA CARTE PORTE LE NOM COURT (Adrien, 07/08/2026 : « pas besoin de repeter mariage
       ici, on est deja dans les panneaux de mariage »). Le nom long reste le H1 de la fiche
       et le titre des cartes de collection, ou il est seul a dire de quel produit il s'agit ;
       repete trois fois sous les vignettes, il n'apporte rien et coupe les libelles sur trois
       lignes. Il demeure en infobulle. */
    /* ⚠️ L'ordre des cartes n'est PAS celui des valeurs cote Shopify : le panneau photo passe en
       dernier parce qu'il demande une photo, les quatre autres se remplissent au clavier. La
       valeur d'option se retrouve par le slug, jamais recopiee ici. */
    [{ id: "bienvenue", nom: T.h1_bienvenue, court: T.type_bienvenue },
     { id: "plan", nom: T.h1_plan, court: T.type_plan },
     { id: "bar", nom: T.h1_bar, court: T.type_bar },
     { id: "voiture", nom: T.h1_voiture, court: T.type_voiture },
     { id: "photo", nom: T.h1_photo, court: T.type_photo }].forEach(function (d) {
      var v = typeValeur(d.id);
      var b = document.createElement("button");
      b.type = "button";
      b.className = "pelemele-gabarit";
      b.setAttribute("data-panneau-type", v);
      b.title = d.nom || d.id;
      b.appendChild(vignetteType(d.id));
      var lab = document.createElement("span");
      lab.textContent = d.court || d.nom || d.id;
      b.appendChild(lab);
      b.addEventListener("click", function () { majType(v); });
      barreTypes.appendChild(b);
    });
  })();
  /* Etat initial : la variante preselectionnee (?variant= des cartes collection). */
  (function () {
    var m = location.search.match(/[?&]variant=(\d+)/);
    if (!m) return;
    var v = (window.__pdpVariants || []).filter(function (x) { return String(x.id) === m[1]; })[0];
    if (v && TYPES[v.option1]) etat.type = TYPES[v.option1];
  })();

  /* ---- Composition d'impression et ajout au panier (patron pele-mele) ---- */
  function composeImpression() {
    return chargePolices().then(function () {
    var c = document.createElement("canvas");
    /* La feuille suit le sens du type : 2200 x 3178 en portrait, 2200 x 1540 sur le panneau
       voiture. Une hauteur en dur imprimait un paysage etire sur un gabarit portrait. */
    c.width = 2200; c.height = Math.round(2200 / ratioCourant());
    dessine(c.getContext("2d"), c.width, c.height, false);
    return new Promise(function (res, rej) {
      c.toBlob(function (b) {
        if (!b) { rej(new Error("toBlob")); return; }
        res(new File([b], "panneau-mariage.jpg", { type: "image/jpeg" }));
      }, "image/jpeg", 0.92);
    });
    });
  }
  function envoie(fichier) {
    var endpoint = window.__persoUpload;
    if (!endpoint) return Promise.resolve(null);
    /* ⛔ `usage=sticker` : UN PANNEAU EST UN STICKER A POSER (Adrien, 07/08/2026, decision D4).
       Le depot le range dans customer_import/stickers/ et le nomme sticker_<horodatage> : sans
       ce parametre il partirait chez les affiches personnalisees, et on ne saurait plus, devant
       le fichier, qu'il s'imprime sur un support rigide. */
    var sep = endpoint.indexOf("?") < 0 ? "?" : "&";
    return fetch(endpoint + sep + "usage=sticker", { method: "POST", headers: { "Content-Type": fichier.type }, body: fichier })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.json().catch(function () { return {}; }).then(function (j) { throw new Error(j.error || r.status); });
      })
      .then(function (j) { if (!j || !j.url) throw new Error("no_url"); return j; });
  }
  function proprietes(j) {
    var props = {
      _perso: "1",
      _perso_url: j.url,
      _perso_preview: j.preview || j.url,
      _perso_crop: "50,50,1.00",
      _perso_crop_ok: "1",
      _perso_orient: "portrait",
      _panneau: "1",
      _panneau_type: etat.type
    };
    if (etat.type !== "photo") props._panneau_fond = etat.fond;
    if (etat.type === "photo") {
      props._panneau_style = etat.style;
      props._panneau_rendu = etat.rendu;
      if (photoDistante) props._panneau_photo_source = photoDistante;
    }
    var textes = {};
    if (etat.type === "bienvenue") {
      if (etat.entete) textes.entete = etat.entete;
      if (etat.prenoms) textes.prenoms = etat.prenoms;
      if (etat.date) textes.date = etat.date;
      if (etat.lieu) textes.lieu = etat.lieu;
      props._panneau_esperluette = etat.esperluette;
    }
    if (etat.type === "plan" && etat.tables) textes.tables = etat.tables;
    if (etat.type === "bar" && etat.bar) textes.bar = etat.bar;
    if (etat.type === "voiture") {
      if (etat.voiture) textes.voiture = etat.voiture;
      if (etat.prenoms) textes.prenoms = etat.prenoms;
      props._panneau_esperluette = etat.esperluette;
    }
    if (etat.type === "photo" && avecTexte()) {
      if (etat.edTitre && !masque("edTitre")) textes.titre = etat.edTitre;
      if (etat.edSous && !masque("edSous")) textes.sous = etat.edSous;
      /* ⛔ LA DATE PART AUSSI, ET SEULEMENT SOUS LE STYLE CENTRE. C'est la troisieme ligne
         IMPRIMEE : absente des proprietes de ligne, elle serait a l'ecran et pas sur le
         panneau, et personne ne le verrait avant la livraison. */
      if (etat.style === "centre" && etat.date && !masque("edDate")) textes.date = etat.date;
      props._panneau_style = etat.style;
    }
    if (Object.keys(textes).length) props._panneau_textes = JSON.stringify(textes);
    if (Object.keys(etat.encres).length) props._panneau_encres = JSON.stringify(etat.encres);
    if (etat.police) props._panneau_police = etat.police;
    return props;
  }
  function majOccupe(actif) {
    [$("#pdp-add"), $("#pdp-sticky-add")].forEach(function (el) {
      if (!el) return;
      el.disabled = actif;
      el.style.opacity = actif ? ".6" : "";
      el.style.cursor = actif ? "progress" : "";
    });
  }
  function requisManquant() {
    if (etat.type === "bienvenue") {
      if (!String(etat.prenoms).trim()) return { champ: "panneau-prenoms", nom: T.prenoms || "Prénoms" };
      if (!String(etat.date).trim()) return { champ: "panneau-date", nom: T.date || "Date" };
    }
    if (etat.type === "plan" && !lignesTables().length) return { champ: "panneau-tables", nom: T.tables || "Tables" };
    if (etat.type === "bar" && !lignesBoissons(etat.bar).length) return { champ: "panneau-bar", nom: T.bar || "Boissons" };
    return null;
  }
  function demandeFormat() {
    var pont = window.__pdpPontPerso || {};
    var gi = pont.groupeFormat && pont.groupeFormat();
    if (gi && gi.grp) {
      gi.grp.scrollIntoView({ behavior: "smooth", block: "center" });
      gi.grp.classList.add("pdp-option--ask");
      setTimeout(function () { gi.grp.classList.remove("pdp-option--ask"); }, 1400);
    }
  }
  function ajoute() {
    if (occupe) return;
    var pont = window.__pdpPontPerso || {};
    if (etat.type === "photo" && !photo) {
      if (window.murToast) window.murToast(T.need_photo || "Importez d'abord votre photo");
      var zoneD = document.getElementById("pdp-upload");
      if (zoneD && !zoneD.hidden) { zoneD.scrollIntoView({ behavior: "smooth", block: "center" }); }
      if (fichierInput) fichierInput.click();
      return;
    }
    var manque = requisManquant();
    if (manque) {
      if (window.murToast) window.murToast((TI.pan_requis || "À compléter : ") + manque.nom);
      var el = document.getElementById(manque.champ);
      if (el) { el.scrollIntoView({ behavior: "smooth", block: "center" }); try { el.focus(); } catch (e) {} }
      return;
    }
    if (pont.formatChoisi && !pont.formatChoisi()) { demandeFormat(); return; }
    /* ⛔ APRES LE FORMAT, JAMAIS AVANT. Ce que le panneau peut porter depend de sa COTE : tant
       qu'elle n'est pas choisie, `planMetrique` travaille sur le 50x70, le plus etroit, et on
       refuserait un plan qui tient parfaitement en 100x140. */
    if (planTropCharge()) {
      if (window.murToast) {
        window.murToast(T.plan_trop
          || "Ce plan de table ne tient pas dans cette taille. Prenez la taille au-dessus, ou retirez quelques noms.");
      }
      var champT = document.getElementById("panneau-tables");
      if (champT) { champT.scrollIntoView({ behavior: "smooth", block: "center" }); try { champT.focus(); } catch (e) {} }
      return;
    }
    var v = pont.varianteCourante && pont.varianteCourante();
    if (!v) return;
    if (window.__persoFunnel) window.__persoFunnel("panier");
    occupe = true; majOccupe(true);
    composeImpression()
      .then(envoie)
      .then(function (j) {
        var qte = 1, qi = document.getElementById("pdp-qty");
        if (qi && Number(qi.textContent) > 0) qte = Math.floor(Number(qi.textContent));
        var items = { items: [{ id: v.id, quantity: qte, properties: proprietes(j) }] };
        if (window.murAddToCart) return window.murAddToCart(items);
        return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(items)
        }).then(function () { if (window.murRefreshCart) return window.murRefreshCart(); });
      })
      .catch(function () {
        if (window.murToast) window.murToast(TI.perso_upload_failed || "Envoi impossible, réessayez");
      })
      .then(function () { occupe = false; majOccupe(false); });
  }
  /* Interception en amont de product.js : en capture sur le document, AVANT la phase
     cible (le meme dessin que pele-mele.js, pour la meme raison). */
  /* ⛔ ON MONTRE AVANT DE VENDRE, ICI AUSSI (Adrien, 20/08/2026 : « pour TOUS LES PRODUITS
     PERSONNALISES [...] EXACTEMENT ce qui est envoye pour impression »). La fenetre vit dans
     `global.js` et ne dessine rien : on lui donne `composeImpression`, la fonction qui fabrique
     le fichier envoye a l'impression, et elle montre son resultat.
     ⚠️ UN PANNEAU N'A PAS DE PHOTO OBLIGATOIRE : contrairement au pele-mele, il se compose
     entierement de texte. Il n'y a donc pas de condition sur les photos, le rendu a toujours
     quelque chose a montrer. */
  function ouvreRendu() {
    if (occupe) return;
    occupe = true; majOccupe(true);
    var st = $("#pdp-sticky-add");
    window.murRenduModale({
      compose: composeImpression,
      fermer: T.fermer,
      libelleAjout: (st && st.getAttribute("data-label-add")) || "Ajouter au panier",
      /* ⛔ LE CHOIX DES TAILLES ET LES OPTIONS ENTRENT DANS LA FENETRE, ils n'y sont pas
         recopies : la liste vit dans `global.js`, une seule fois pour les trois
         configurateurs. Sans eux, le client voyait son rendu puis retombait sur
         « Choisissez une taille » a la fermeture. */
      commandes: window.murCommandesAchat,
      quantite: ".pdp-buy-actions > .pdp-qty-sel",
      reassurance: ".pdp-avis__note",
      onAjouter: ajoute,
    }).catch(function () {
      if (window.murToast) window.murToast("Rendu impossible, réessayez");
    }).then(function () { occupe = false; majOccupe(false); });
  }
  /* ⛔ ET LA PAGE NE GARDE PAS SON BLOC D'ACHAT EN DOUBLE quand la fenetre est le chemin (Adrien,
     20/08/2026). Le panneau n'attend aucune photo : sur telephone, sa fenetre est TOUJOURS le
     chemin d'achat, donc la condition tient dans le seuil. `global.js` la rejoue au pivotement. */
  if (window.murAchatParModale) {
    window.murAchatParModale(function () {
      return !!(window.murEstMobile && window.murEstMobile());
    });
  }
  /* ⛔ ET LE LIBELLE SUIT LE SEUIL, PAS SEULEMENT LE CHARGEMENT. `murAchatParModale` rejoue son
     drapeau au pivotement, mais lui seul : sans ce rappel, un telephone tourne en paysage
     repassait au chemin d'achat direct avec un bouton qui disait encore « Voir le rendu ».
     ⚠️ `majCta` ne reecrit que si la tete differe : le rappel ne coute rien et ne boucle pas. */
  if (window.matchMedia) {
    var seuil = window.matchMedia("(max-width:900px)");
    var suivreSeuil = function () { majCta(); };
    if (seuil.addEventListener) seuil.addEventListener("change", suivreSeuil);
    else if (seuil.addListener) seuil.addListener(suivreSeuil);
  }
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest("#pdp-add, #pdp-sticky-add")) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      /* ⛔ MOBILE SEULEMENT (Adrien, 20/08/2026) : sur grand ecran l'apercu occupe deja la
         moitie de la page, et une fenetre qui le remontre ajoute un clic sans rien apprendre. */
      if (window.murEstMobile && window.murEstMobile()) ouvreRendu(); else ajoute();
    }
  }, true);

  /* ---- Encres par champ : la pastille de chaque champ ouvre la palette de la perso
     (le meme dessin et la meme mecanique que les champs du pele-mele). Re-cliquer la
     teinte active revient a l'automatique. ---- */
  function majPastilles() {
    Array.prototype.forEach.call(zone.querySelectorAll("[data-panneau-encre-champ]"), function (b) {
      var sw = b.querySelector(".perso-text__swatch");
      /* ⛔ LA PASTILLE MONTRE L'ENCRE DU FOND COURANT, PAS UN NOIR EN DUR. Elle affichait
         `#1d1d1b` tant que le client n'avait rien choisi, alors que l'apercu ecrit deja dans
         `FONDS[fond].encre` : creme sur les fonds fonces. La pastille annoncait donc une
         couleur que le panneau n'utilisait pas (Adrien, 06/08/2026 : « par defaut la couleur
         de la pastille du texte n'est pas celle affichee dans le placeholder »). Le defaut
         est desormais lu au meme endroit que le dessin, ligne 137 et suivantes. */
      if (sw) sw.style.background = encreDe(b.getAttribute("data-panneau-encre-champ"), encreDefaut());
    });
  }
  /* ---- La police d'UN texte ----------------------------------------------------------
     Meme geste que l'encre, et c'est voulu : deux boutons voisins qui ouvrent deux fenetres
     de formes differentes obligeraient a apprendre deux fois la meme chose. */
  var modalePolice = null, champPoliceOuvert = null;
  function majPastillesPolice() {
    Array.prototype.forEach.call(zone.querySelectorAll("[data-panneau-police-champ]"), function (b) {
      var ex = b.querySelector(".perso-text__font-ex");
      if (ex) ex.style.fontFamily = serifDe(b.getAttribute("data-panneau-police-champ"));
      /* Le bouton se marque quand ce texte NE SUIT PLUS la police du panneau. */
      b.classList.toggle("is-on", !!etat.polices[b.getAttribute("data-panneau-police-champ")]);
    });
  }
  function majModalePolice() {
    if (!modalePolice) return;
    Array.prototype.forEach.call(modalePolice.querySelectorAll("[data-panneau-modale-police]"), function (b) {
      var on = etat.polices[champPoliceOuvert] === b.getAttribute("data-panneau-modale-police");
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  function fermeModalePolice() { if (modalePolice) modalePolice.hidden = true; champPoliceOuvert = null; }
  function ouvreModalePolice(cle) {
    champPoliceOuvert = cle;
    if (!modalePolice) {
      modalePolice = document.createElement("div");
      modalePolice.className = "perso-ink-modal pelemele-ink-modal";
      modalePolice.setAttribute("role", "dialog");
      modalePolice.setAttribute("aria-modal", "true");
      var pan = document.createElement("div");
      pan.className = "perso-ink-modal__panel sans";
      var tete = document.createElement("div");
      tete.className = "perso-ink-modal__head";
      var titre = document.createElement("span");
      titre.textContent = T.police || "Police";
      var fermer = document.createElement("button");
      fermer.type = "button";
      fermer.className = "perso-ink-modal__x";
      fermer.textContent = "×";
      fermer.setAttribute("aria-label", T.fermer || "Fermer");
      fermer.addEventListener("click", fermeModalePolice);
      tete.appendChild(titre); tete.appendChild(fermer);
      pan.appendChild(tete);
      var grille = document.createElement("div");
      grille.className = "perso-modale-polices";
      Object.keys(POLICES).forEach(function (id) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "perso-text__font";
        b.setAttribute("data-panneau-modale-police", id);
        b.style.fontFamily = POLICES[id];
        b.textContent = "Aa";
        b.addEventListener("click", function () {
          /* ⚠️ RECLIQUER LA POLICE POSEE LA RETIRE : le texte reprend alors celle du panneau,
             comme l'encre reprend celle du fond. Sans ce retour, un choix par champ ne se
             defait plus qu'en changeant la police globale, ce qui deplace tous les autres. */
          if (etat.polices[champPoliceOuvert] === id) delete etat.polices[champPoliceOuvert];
          else etat.polices[champPoliceOuvert] = id;
          /* ⚠️ ON CHARGE AVANT DE REDESSINER : une police choisie a l'instant n'est pas encore
             telechargee, et le premier trace la manquerait, a l'ecran comme dans le fichier. */
          majModalePolice(); majPastillesPolice(); persiste();
          chargePolices().then(function () { planifie(); majPastillesPolice(); });
        });
        grille.appendChild(b);
      });
      pan.appendChild(grille);
      modalePolice.appendChild(pan);
      modalePolice.addEventListener("click", function (e) {
        if (e.target === modalePolice) fermeModalePolice();
      });
      document.body.appendChild(modalePolice);
    }
    majModalePolice();
    modalePolice.hidden = false;
  }
  zone.addEventListener("click", function (e) {
    var b = e.target && e.target.closest ? e.target.closest("[data-panneau-police-champ]") : null;
    if (!b) return;
    ouvreModalePolice(b.getAttribute("data-panneau-police-champ"));
  });

  var modaleEncre = null, champEncreOuvert = null;
  function majModaleEncre() {
    if (!modaleEncre) return;
    Array.prototype.forEach.call(modaleEncre.querySelectorAll("[data-panneau-modale-encre]"), function (b) {
      var on = etat.encres[champEncreOuvert] === b.getAttribute("data-panneau-modale-encre");
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  function fermeModaleEncre() { if (modaleEncre) modaleEncre.hidden = true; champEncreOuvert = null; }
  function ouvreModaleEncre(cle) {
    champEncreOuvert = cle;
    if (!modaleEncre) {
      modaleEncre = document.createElement("div");
      modaleEncre.className = "perso-ink-modal pelemele-ink-modal";
      modaleEncre.setAttribute("role", "dialog");
      modaleEncre.setAttribute("aria-modal", "true");
      var panneauM = document.createElement("div");
      panneauM.className = "perso-ink-modal__panel sans";
      var tete = document.createElement("div");
      tete.className = "perso-ink-modal__head";
      var titre = document.createElement("span");
      titre.textContent = T.encre || "Couleur du texte";
      var fermer = document.createElement("button");
      fermer.type = "button";
      fermer.className = "perso-ink-modal__x";
      fermer.textContent = "×";
      fermer.setAttribute("aria-label", T.fermer || "Fermer");
      fermer.addEventListener("click", fermeModaleEncre);
      tete.appendChild(titre); tete.appendChild(fermer);
      panneauM.appendChild(tete);
      var grille = document.createElement("div");
      grille.className = "perso-text__color-grid";
      Object.keys(MATS).forEach(function (mat) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "perso-text__color";
        b.setAttribute("data-panneau-modale-encre", mat);
        var sw = document.createElement("span");
        sw.className = "perso-text__swatch";
        sw.style.background = MATS[mat];
        b.appendChild(sw);
        b.addEventListener("click", function () {
          if (etat.encres[champEncreOuvert] === mat) delete etat.encres[champEncreOuvert];
          else etat.encres[champEncreOuvert] = mat;
          majModaleEncre(); majPastilles(); planifie(); persiste();
        });
        grille.appendChild(b);
      });
      panneauM.appendChild(grille);
      modaleEncre.appendChild(panneauM);
      modaleEncre.addEventListener("click", function (e) { if (e.target === modaleEncre) fermeModaleEncre(); });
      document.body.appendChild(modaleEncre);
    }
    majModaleEncre();
    modaleEncre.hidden = false;
  }
  Array.prototype.forEach.call(zone.querySelectorAll("[data-panneau-encre-champ]"), function (b) {
    b.addEventListener("click", function () { ouvreModaleEncre(b.getAttribute("data-panneau-encre-champ")); });
  });

  /* ---- La police : la grille de la perso, aucun bouton actif = la serif du dessin. ---- */
  var grillePolices = document.getElementById("panneau-polices");
  function majPolices() {
    if (!grillePolices) return;
    Array.prototype.forEach.call(grillePolices.querySelectorAll("[data-panneau-police]"), function (b) {
      var on = b.getAttribute("data-panneau-police") === etat.police;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  /* ---- Les trois esperluettes, meme grille que les polices. Une seule est active a la
     fois : contrairement aux polices, il n'y a pas d'etat « aucune » : deux prenoms sont
     toujours relies par quelque chose. ---- */
  var grilleEsp = document.getElementById("panneau-esperluettes");
  function majEsperluettes() {
    if (!grilleEsp) return;
    Array.prototype.forEach.call(grilleEsp.querySelectorAll("[data-panneau-esp]"), function (b) {
      var on = b.getAttribute("data-panneau-esp") === etat.esperluette;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  grilleEsp && grilleEsp.addEventListener("click", function (e) {
    var b = e.target && e.target.closest ? e.target.closest("[data-panneau-esp]") : null;
    if (!b) return;
    var id = b.getAttribute("data-panneau-esp");
    if (!ESPERLUETTES[id]) return;
    etat.esperluette = id;
    majEsperluettes(); planifie(); majVignettes(); persiste();
  });

  grillePolices && grillePolices.addEventListener("click", function (e) {
    var b = e.target && e.target.closest ? e.target.closest("[data-panneau-police]") : null;
    if (!b) return;
    var id = b.getAttribute("data-panneau-police");
    etat.police = etat.police === id ? "" : id;
    majPolices(); planifie(); majVignettes(); persiste();
    chargePolices().then(function () { planifie(); majVignettes(); });
  });

  /* ---- Rien ne se perd au rechargement (Adrien, 04/08/2026) ----
     Les textes, encres, police, fond, style et rendu reviennent par l'etat (session).
     La PHOTO revient depuis son URL de depot (le patron du pele : URLs stables,
     crossOrigin anonymous). La TAILLE re-presse sa pilule et la PERFORATION re-coche
     sa case APRES l'init de product.js (les deux scripts sont defer, dans l'ordre :
     un setTimeout(0) part apres son execution). L'URL suit la variante courante
     (replaceState) : un rechargement retombe sur le bon type et la bonne finition. */
  function restaurePhoto() {
    if (!etat.photoUrl || photo) return;
    var img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function () {
      photo = { bmp: img, w: img.naturalWidth, h: img.naturalHeight };
      photoDistante = etat.photoUrl;
      var bloc = document.getElementById("pdp-photo-block");
      var zoneD = document.getElementById("pdp-upload");
      if (bloc) bloc.hidden = false;
      if (zoneD) zoneD.hidden = true;
      var mini = document.getElementById("pdp-photo-thumb");
      if (mini) {
        var c = document.createElement("canvas");
        c.width = 96; c.height = 96;
        poseCover(c.getContext("2d"), img, img.naturalWidth, img.naturalHeight, 0, 0, 96, 96, false);
        mini.style.backgroundImage = "url('" + c.toDataURL("image/jpeg", 0.8) + "')";
      }
      planifie(); majVignettes(); majCta();
    };
    img.src = etat.photoPreview || etat.photoUrl;
  }
  function varianteCourantePanneau() {
    var taille = etat.taille || "50X70";
    var fin = etat.perfo ? FIN[1] : FIN[0];
    return (window.__pdpVariants || []).filter(function (v) {
      return v.option1 === typeValeur() && v.option2 === taille && v.option3 === fin;
    })[0] || null;
  }
  function majUrl() {
    var v = varianteCourantePanneau();
    if (!v) return;
    try {
      var url = new URL(location.href);
      url.searchParams.set("variant", String(v.id));
      history.replaceState(history.state, "", url.pathname + url.search);
    } catch (e) {}
  }
  var ligneTaille = document.querySelector('[data-option-index="1"]');
  ligneTaille && ligneTaille.addEventListener("click", function (e) {
    var b = e.target && e.target.closest ? e.target.closest("[data-value]") : null;
    if (!b) return;
    etat.taille = b.getAttribute("data-value");
    /* La taille porte desormais le RAPPORT du panneau : le cadre, les cotes, la bande et
       l'apercu doivent suivre le clic (un 50 x 35 bascule le panneau en paysage). */
    persiste(); majUrl(); majBlocs(); planifie();
  });
  setTimeout(function () {
    var caseP = document.getElementById("pdp-up-perfo-check");
    if (caseP) {
      /* ⛔ LA CASE REPREND LE CHOIX DU CLIENT, JAMAIS L'ETAT FORCE. Elle se relisait sur
         `etat.perfo`, que le panneau voiture met a `true` : une seule visite sur ce type
         suffisait a la recocher a chaque rechargement, sur n'importe quel autre panneau. */
      caseP.addEventListener("change", function () {
        etat.perfoClient = caseP.checked;
        if (etat.type !== "voiture") etat.perfo = caseP.checked;
        persiste(); majUrl();
      });
      if (caseP.checked !== !!etat.perfoClient) {
        caseP.checked = !!etat.perfoClient;
        caseP.dispatchEvent(new Event("change"));
      } else if (etat.type !== "voiture") {
        etat.perfo = etat.perfoClient;
      }
    }
    if (etat.taille && ligneTaille) {
      var pill = ligneTaille.querySelector('[data-value="' + etat.taille + '"]');
      /* ⛔ UNE TAILLE GARDEE DE LA VISITE D'AVANT PEUT NE PLUS EXISTER POUR CE TYPE. Le 50 x 35
         n'appartient qu'au panneau voiture : restaure telle quelle sur un panneau de bienvenue,
         elle pressait une pilule masquee, et les cotes annoncaient « 50 cm » sur « 35 cm » a
         cote d'un panneau qui fait 50 sur 70 (Adrien, 07/08/2026 : « les dimensions des
         placeholders sont fausses »). Cette reprise s'execute APRES `majPrixTailles`, donc
         apres le garde-fou qui devait rattraper ce cas : elle le defaisait. On oublie la taille
         perimee et on laisse le type choisir la sienne. */
      if (pill && pill.hidden) { etat.taille = ""; pill = null; persiste(); majPrixTailles(); }
      if (pill && pill.getAttribute("aria-pressed") !== "true") pill.click();
    }
    restaurePhoto();
  }, 0);

  /* ---- Depart ---- */
  chargeDecors();
  synchronisePilules(); majBarreTypes(); majH1(); majBlocs(); majPrixTailles(); planifie(); majVignettes();
  majPastilles(); majPastillesPolice(); majPolices(); majEsperluettes();
  /* La calligraphie arrive apres le premier trace : on redessine quand elle est la, sinon le
     visiteur voit l'esperluette de repli pendant une seconde et le systeme la lui laisse. */
  chargePolices().then(function () { planifie(); majVignettes(); });
  setTimeout(majCta, 0);

  /* Sonde de verification (aucun usage client) : rendre un etat arbitraire hors ecran.
     Elle sert aussi a REFAIRE LES MEDIAS DE LA FICHE quand le dessin change : les cartes de la
     collection montrent `p.media[0..2]`, des JPG figes qui ne suivent pas le configurateur, et
     un client a deja vu la carte d'un panneau que le produit ne sait plus faire. D'ou la
     qualite en argument : 0,72 suffit pour verifier a l'oeil, pas pour une image de vente. */
  window.__pdpPanneauSonde = function (surcharge, largeur, qualite) {
    var sauve = JSON.parse(JSON.stringify(etat));
    Object.keys(surcharge || {}).forEach(function (k) { etat[k] = surcharge[k]; });
    var c = document.createElement("canvas");
    c.width = largeur || 400; c.height = Math.round(c.width / ratioCourant());
    dessine(c.getContext("2d"), c.width, c.height, true);
    var d = c.toDataURL("image/jpeg", qualite || 0.72);
    Object.keys(etat).forEach(function (k) { etat[k] = sauve[k]; });
    return d;
  };
})();
